/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bytea: { input: any; output: any; }
  numeric: { input: number; output: number; }
  timestamptz: { input: string; output: string; }
  uuid: { input: string; output: string; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type Bytea_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bytea']['input']>;
  _gt?: InputMaybe<Scalars['bytea']['input']>;
  _gte?: InputMaybe<Scalars['bytea']['input']>;
  _in?: InputMaybe<Array<Scalars['bytea']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bytea']['input']>;
  _lte?: InputMaybe<Scalars['bytea']['input']>;
  _neq?: InputMaybe<Scalars['bytea']['input']>;
  _nin?: InputMaybe<Array<Scalars['bytea']['input']>>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "printweb.background_material" */
  delete_printweb_background_material?: Maybe<Printweb_Background_Material_Mutation_Response>;
  /** delete single row from the table: "printweb.background_material" */
  delete_printweb_background_material_by_pk?: Maybe<Printweb_Background_Material>;
  /** delete data from the table: "printweb.background_material_group" */
  delete_printweb_background_material_group?: Maybe<Printweb_Background_Material_Group_Mutation_Response>;
  /** delete single row from the table: "printweb.background_material_group" */
  delete_printweb_background_material_group_by_pk?: Maybe<Printweb_Background_Material_Group>;
  /** delete data from the table: "printweb.combinable_spot_colors" */
  delete_printweb_combinable_spot_colors?: Maybe<Printweb_Combinable_Spot_Colors_Mutation_Response>;
  /** delete single row from the table: "printweb.combinable_spot_colors" */
  delete_printweb_combinable_spot_colors_by_pk?: Maybe<Printweb_Combinable_Spot_Colors>;
  /** delete data from the table: "printweb.instance" */
  delete_printweb_instance?: Maybe<Printweb_Instance_Mutation_Response>;
  /** delete data from the table: "printweb.instance_background_material" */
  delete_printweb_instance_background_material?: Maybe<Printweb_Instance_Background_Material_Mutation_Response>;
  /** delete single row from the table: "printweb.instance_background_material" */
  delete_printweb_instance_background_material_by_pk?: Maybe<Printweb_Instance_Background_Material>;
  /** delete single row from the table: "printweb.instance" */
  delete_printweb_instance_by_pk?: Maybe<Printweb_Instance>;
  /** delete data from the table: "printweb.instance_spot_color" */
  delete_printweb_instance_spot_color?: Maybe<Printweb_Instance_Spot_Color_Mutation_Response>;
  /** delete single row from the table: "printweb.instance_spot_color" */
  delete_printweb_instance_spot_color_by_pk?: Maybe<Printweb_Instance_Spot_Color>;
  /** delete data from the table: "printweb.material_group" */
  delete_printweb_material_group?: Maybe<Printweb_Material_Group_Mutation_Response>;
  /** delete single row from the table: "printweb.material_group" */
  delete_printweb_material_group_by_pk?: Maybe<Printweb_Material_Group>;
  /** delete data from the table: "printweb.material_label" */
  delete_printweb_material_label?: Maybe<Printweb_Material_Label_Mutation_Response>;
  /** delete single row from the table: "printweb.material_label" */
  delete_printweb_material_label_by_pk?: Maybe<Printweb_Material_Label>;
  /** delete data from the table: "printweb.spot_color" */
  delete_printweb_spot_color?: Maybe<Printweb_Spot_Color_Mutation_Response>;
  /** delete single row from the table: "printweb.spot_color" */
  delete_printweb_spot_color_by_pk?: Maybe<Printweb_Spot_Color>;
  /** insert data into the table: "printweb.background_material" */
  insert_printweb_background_material?: Maybe<Printweb_Background_Material_Mutation_Response>;
  /** insert data into the table: "printweb.background_material_group" */
  insert_printweb_background_material_group?: Maybe<Printweb_Background_Material_Group_Mutation_Response>;
  /** insert a single row into the table: "printweb.background_material_group" */
  insert_printweb_background_material_group_one?: Maybe<Printweb_Background_Material_Group>;
  /** insert a single row into the table: "printweb.background_material" */
  insert_printweb_background_material_one?: Maybe<Printweb_Background_Material>;
  /** insert data into the table: "printweb.combinable_spot_colors" */
  insert_printweb_combinable_spot_colors?: Maybe<Printweb_Combinable_Spot_Colors_Mutation_Response>;
  /** insert a single row into the table: "printweb.combinable_spot_colors" */
  insert_printweb_combinable_spot_colors_one?: Maybe<Printweb_Combinable_Spot_Colors>;
  /** insert data into the table: "printweb.instance" */
  insert_printweb_instance?: Maybe<Printweb_Instance_Mutation_Response>;
  /** insert data into the table: "printweb.instance_background_material" */
  insert_printweb_instance_background_material?: Maybe<Printweb_Instance_Background_Material_Mutation_Response>;
  /** insert a single row into the table: "printweb.instance_background_material" */
  insert_printweb_instance_background_material_one?: Maybe<Printweb_Instance_Background_Material>;
  /** insert a single row into the table: "printweb.instance" */
  insert_printweb_instance_one?: Maybe<Printweb_Instance>;
  /** insert data into the table: "printweb.instance_spot_color" */
  insert_printweb_instance_spot_color?: Maybe<Printweb_Instance_Spot_Color_Mutation_Response>;
  /** insert a single row into the table: "printweb.instance_spot_color" */
  insert_printweb_instance_spot_color_one?: Maybe<Printweb_Instance_Spot_Color>;
  /** insert data into the table: "printweb.material_group" */
  insert_printweb_material_group?: Maybe<Printweb_Material_Group_Mutation_Response>;
  /** insert a single row into the table: "printweb.material_group" */
  insert_printweb_material_group_one?: Maybe<Printweb_Material_Group>;
  /** insert data into the table: "printweb.material_label" */
  insert_printweb_material_label?: Maybe<Printweb_Material_Label_Mutation_Response>;
  /** insert a single row into the table: "printweb.material_label" */
  insert_printweb_material_label_one?: Maybe<Printweb_Material_Label>;
  /** insert data into the table: "printweb.spot_color" */
  insert_printweb_spot_color?: Maybe<Printweb_Spot_Color_Mutation_Response>;
  /** insert a single row into the table: "printweb.spot_color" */
  insert_printweb_spot_color_one?: Maybe<Printweb_Spot_Color>;
  /** update data of the table: "printweb.background_material" */
  update_printweb_background_material?: Maybe<Printweb_Background_Material_Mutation_Response>;
  /** update single row of the table: "printweb.background_material" */
  update_printweb_background_material_by_pk?: Maybe<Printweb_Background_Material>;
  /** update data of the table: "printweb.background_material_group" */
  update_printweb_background_material_group?: Maybe<Printweb_Background_Material_Group_Mutation_Response>;
  /** update single row of the table: "printweb.background_material_group" */
  update_printweb_background_material_group_by_pk?: Maybe<Printweb_Background_Material_Group>;
  /** update multiples rows of table: "printweb.background_material_group" */
  update_printweb_background_material_group_many?: Maybe<Array<Maybe<Printweb_Background_Material_Group_Mutation_Response>>>;
  /** update multiples rows of table: "printweb.background_material" */
  update_printweb_background_material_many?: Maybe<Array<Maybe<Printweb_Background_Material_Mutation_Response>>>;
  /** update data of the table: "printweb.combinable_spot_colors" */
  update_printweb_combinable_spot_colors?: Maybe<Printweb_Combinable_Spot_Colors_Mutation_Response>;
  /** update single row of the table: "printweb.combinable_spot_colors" */
  update_printweb_combinable_spot_colors_by_pk?: Maybe<Printweb_Combinable_Spot_Colors>;
  /** update multiples rows of table: "printweb.combinable_spot_colors" */
  update_printweb_combinable_spot_colors_many?: Maybe<Array<Maybe<Printweb_Combinable_Spot_Colors_Mutation_Response>>>;
  /** update data of the table: "printweb.instance" */
  update_printweb_instance?: Maybe<Printweb_Instance_Mutation_Response>;
  /** update data of the table: "printweb.instance_background_material" */
  update_printweb_instance_background_material?: Maybe<Printweb_Instance_Background_Material_Mutation_Response>;
  /** update single row of the table: "printweb.instance_background_material" */
  update_printweb_instance_background_material_by_pk?: Maybe<Printweb_Instance_Background_Material>;
  /** update multiples rows of table: "printweb.instance_background_material" */
  update_printweb_instance_background_material_many?: Maybe<Array<Maybe<Printweb_Instance_Background_Material_Mutation_Response>>>;
  /** update single row of the table: "printweb.instance" */
  update_printweb_instance_by_pk?: Maybe<Printweb_Instance>;
  /** update multiples rows of table: "printweb.instance" */
  update_printweb_instance_many?: Maybe<Array<Maybe<Printweb_Instance_Mutation_Response>>>;
  /** update data of the table: "printweb.instance_spot_color" */
  update_printweb_instance_spot_color?: Maybe<Printweb_Instance_Spot_Color_Mutation_Response>;
  /** update single row of the table: "printweb.instance_spot_color" */
  update_printweb_instance_spot_color_by_pk?: Maybe<Printweb_Instance_Spot_Color>;
  /** update multiples rows of table: "printweb.instance_spot_color" */
  update_printweb_instance_spot_color_many?: Maybe<Array<Maybe<Printweb_Instance_Spot_Color_Mutation_Response>>>;
  /** update data of the table: "printweb.material_group" */
  update_printweb_material_group?: Maybe<Printweb_Material_Group_Mutation_Response>;
  /** update single row of the table: "printweb.material_group" */
  update_printweb_material_group_by_pk?: Maybe<Printweb_Material_Group>;
  /** update multiples rows of table: "printweb.material_group" */
  update_printweb_material_group_many?: Maybe<Array<Maybe<Printweb_Material_Group_Mutation_Response>>>;
  /** update data of the table: "printweb.material_label" */
  update_printweb_material_label?: Maybe<Printweb_Material_Label_Mutation_Response>;
  /** update single row of the table: "printweb.material_label" */
  update_printweb_material_label_by_pk?: Maybe<Printweb_Material_Label>;
  /** update multiples rows of table: "printweb.material_label" */
  update_printweb_material_label_many?: Maybe<Array<Maybe<Printweb_Material_Label_Mutation_Response>>>;
  /** update data of the table: "printweb.spot_color" */
  update_printweb_spot_color?: Maybe<Printweb_Spot_Color_Mutation_Response>;
  /** update single row of the table: "printweb.spot_color" */
  update_printweb_spot_color_by_pk?: Maybe<Printweb_Spot_Color>;
  /** update multiples rows of table: "printweb.spot_color" */
  update_printweb_spot_color_many?: Maybe<Array<Maybe<Printweb_Spot_Color_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_Printweb_Background_MaterialArgs = {
  where: Printweb_Background_Material_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Printweb_Background_Material_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Printweb_Background_Material_GroupArgs = {
  where: Printweb_Background_Material_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Printweb_Background_Material_Group_By_PkArgs = {
  background_material_id: Scalars['uuid']['input'];
  material_group_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Printweb_Combinable_Spot_ColorsArgs = {
  where: Printweb_Combinable_Spot_Colors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Printweb_Combinable_Spot_Colors_By_PkArgs = {
  combinable_spot_color_id: Scalars['uuid']['input'];
  spot_color_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Printweb_InstanceArgs = {
  where: Printweb_Instance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Printweb_Instance_Background_MaterialArgs = {
  where: Printweb_Instance_Background_Material_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Printweb_Instance_Background_Material_By_PkArgs = {
  background_material_id: Scalars['uuid']['input'];
  instance_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Printweb_Instance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Printweb_Instance_Spot_ColorArgs = {
  where: Printweb_Instance_Spot_Color_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Printweb_Instance_Spot_Color_By_PkArgs = {
  instance_id: Scalars['uuid']['input'];
  spot_color_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Printweb_Material_GroupArgs = {
  where: Printweb_Material_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Printweb_Material_Group_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Printweb_Material_LabelArgs = {
  where: Printweb_Material_Label_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Printweb_Material_Label_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Printweb_Spot_ColorArgs = {
  where: Printweb_Spot_Color_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Printweb_Spot_Color_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsert_Printweb_Background_MaterialArgs = {
  objects: Array<Printweb_Background_Material_Insert_Input>;
  on_conflict?: InputMaybe<Printweb_Background_Material_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printweb_Background_Material_GroupArgs = {
  objects: Array<Printweb_Background_Material_Group_Insert_Input>;
  on_conflict?: InputMaybe<Printweb_Background_Material_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printweb_Background_Material_Group_OneArgs = {
  object: Printweb_Background_Material_Group_Insert_Input;
  on_conflict?: InputMaybe<Printweb_Background_Material_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printweb_Background_Material_OneArgs = {
  object: Printweb_Background_Material_Insert_Input;
  on_conflict?: InputMaybe<Printweb_Background_Material_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printweb_Combinable_Spot_ColorsArgs = {
  objects: Array<Printweb_Combinable_Spot_Colors_Insert_Input>;
  on_conflict?: InputMaybe<Printweb_Combinable_Spot_Colors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printweb_Combinable_Spot_Colors_OneArgs = {
  object: Printweb_Combinable_Spot_Colors_Insert_Input;
  on_conflict?: InputMaybe<Printweb_Combinable_Spot_Colors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printweb_InstanceArgs = {
  objects: Array<Printweb_Instance_Insert_Input>;
  on_conflict?: InputMaybe<Printweb_Instance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printweb_Instance_Background_MaterialArgs = {
  objects: Array<Printweb_Instance_Background_Material_Insert_Input>;
  on_conflict?: InputMaybe<Printweb_Instance_Background_Material_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printweb_Instance_Background_Material_OneArgs = {
  object: Printweb_Instance_Background_Material_Insert_Input;
  on_conflict?: InputMaybe<Printweb_Instance_Background_Material_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printweb_Instance_OneArgs = {
  object: Printweb_Instance_Insert_Input;
  on_conflict?: InputMaybe<Printweb_Instance_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printweb_Instance_Spot_ColorArgs = {
  objects: Array<Printweb_Instance_Spot_Color_Insert_Input>;
  on_conflict?: InputMaybe<Printweb_Instance_Spot_Color_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printweb_Instance_Spot_Color_OneArgs = {
  object: Printweb_Instance_Spot_Color_Insert_Input;
  on_conflict?: InputMaybe<Printweb_Instance_Spot_Color_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printweb_Material_GroupArgs = {
  objects: Array<Printweb_Material_Group_Insert_Input>;
  on_conflict?: InputMaybe<Printweb_Material_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printweb_Material_Group_OneArgs = {
  object: Printweb_Material_Group_Insert_Input;
  on_conflict?: InputMaybe<Printweb_Material_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printweb_Material_LabelArgs = {
  objects: Array<Printweb_Material_Label_Insert_Input>;
  on_conflict?: InputMaybe<Printweb_Material_Label_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printweb_Material_Label_OneArgs = {
  object: Printweb_Material_Label_Insert_Input;
  on_conflict?: InputMaybe<Printweb_Material_Label_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printweb_Spot_ColorArgs = {
  objects: Array<Printweb_Spot_Color_Insert_Input>;
  on_conflict?: InputMaybe<Printweb_Spot_Color_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Printweb_Spot_Color_OneArgs = {
  object: Printweb_Spot_Color_Insert_Input;
  on_conflict?: InputMaybe<Printweb_Spot_Color_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Background_MaterialArgs = {
  _set?: InputMaybe<Printweb_Background_Material_Set_Input>;
  where: Printweb_Background_Material_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Background_Material_By_PkArgs = {
  _set?: InputMaybe<Printweb_Background_Material_Set_Input>;
  pk_columns: Printweb_Background_Material_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Background_Material_GroupArgs = {
  _set?: InputMaybe<Printweb_Background_Material_Group_Set_Input>;
  where: Printweb_Background_Material_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Background_Material_Group_By_PkArgs = {
  _set?: InputMaybe<Printweb_Background_Material_Group_Set_Input>;
  pk_columns: Printweb_Background_Material_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Background_Material_Group_ManyArgs = {
  updates: Array<Printweb_Background_Material_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Background_Material_ManyArgs = {
  updates: Array<Printweb_Background_Material_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Combinable_Spot_ColorsArgs = {
  _set?: InputMaybe<Printweb_Combinable_Spot_Colors_Set_Input>;
  where: Printweb_Combinable_Spot_Colors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Combinable_Spot_Colors_By_PkArgs = {
  _set?: InputMaybe<Printweb_Combinable_Spot_Colors_Set_Input>;
  pk_columns: Printweb_Combinable_Spot_Colors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Combinable_Spot_Colors_ManyArgs = {
  updates: Array<Printweb_Combinable_Spot_Colors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_InstanceArgs = {
  _set?: InputMaybe<Printweb_Instance_Set_Input>;
  where: Printweb_Instance_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Instance_Background_MaterialArgs = {
  _set?: InputMaybe<Printweb_Instance_Background_Material_Set_Input>;
  where: Printweb_Instance_Background_Material_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Instance_Background_Material_By_PkArgs = {
  _set?: InputMaybe<Printweb_Instance_Background_Material_Set_Input>;
  pk_columns: Printweb_Instance_Background_Material_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Instance_Background_Material_ManyArgs = {
  updates: Array<Printweb_Instance_Background_Material_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Instance_By_PkArgs = {
  _set?: InputMaybe<Printweb_Instance_Set_Input>;
  pk_columns: Printweb_Instance_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Instance_ManyArgs = {
  updates: Array<Printweb_Instance_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Instance_Spot_ColorArgs = {
  _set?: InputMaybe<Printweb_Instance_Spot_Color_Set_Input>;
  where: Printweb_Instance_Spot_Color_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Instance_Spot_Color_By_PkArgs = {
  _set?: InputMaybe<Printweb_Instance_Spot_Color_Set_Input>;
  pk_columns: Printweb_Instance_Spot_Color_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Instance_Spot_Color_ManyArgs = {
  updates: Array<Printweb_Instance_Spot_Color_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Material_GroupArgs = {
  _set?: InputMaybe<Printweb_Material_Group_Set_Input>;
  where: Printweb_Material_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Material_Group_By_PkArgs = {
  _set?: InputMaybe<Printweb_Material_Group_Set_Input>;
  pk_columns: Printweb_Material_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Material_Group_ManyArgs = {
  updates: Array<Printweb_Material_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Material_LabelArgs = {
  _set?: InputMaybe<Printweb_Material_Label_Set_Input>;
  where: Printweb_Material_Label_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Material_Label_By_PkArgs = {
  _set?: InputMaybe<Printweb_Material_Label_Set_Input>;
  pk_columns: Printweb_Material_Label_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Material_Label_ManyArgs = {
  updates: Array<Printweb_Material_Label_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Spot_ColorArgs = {
  _inc?: InputMaybe<Printweb_Spot_Color_Inc_Input>;
  _set?: InputMaybe<Printweb_Spot_Color_Set_Input>;
  where: Printweb_Spot_Color_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Spot_Color_By_PkArgs = {
  _inc?: InputMaybe<Printweb_Spot_Color_Inc_Input>;
  _set?: InputMaybe<Printweb_Spot_Color_Set_Input>;
  pk_columns: Printweb_Spot_Color_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Printweb_Spot_Color_ManyArgs = {
  updates: Array<Printweb_Spot_Color_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "printweb.background_material" */
export type Printweb_Background_Material = {
  __typename?: 'printweb_background_material';
  /** An array relationship */
  background_material_groups: Array<Printweb_Background_Material_Group>;
  /** An aggregate relationship */
  background_material_groups_aggregate: Printweb_Background_Material_Group_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  display_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  image: Scalars['bytea']['output'];
  internal_name: Scalars['String']['output'];
  label_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  material_label?: Maybe<Printweb_Material_Label>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "printweb.background_material" */
export type Printweb_Background_MaterialBackground_Material_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Background_Material_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Background_Material_Group_Order_By>>;
  where?: InputMaybe<Printweb_Background_Material_Group_Bool_Exp>;
};


/** columns and relationships of "printweb.background_material" */
export type Printweb_Background_MaterialBackground_Material_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Background_Material_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Background_Material_Group_Order_By>>;
  where?: InputMaybe<Printweb_Background_Material_Group_Bool_Exp>;
};

/** aggregated selection of "printweb.background_material" */
export type Printweb_Background_Material_Aggregate = {
  __typename?: 'printweb_background_material_aggregate';
  aggregate?: Maybe<Printweb_Background_Material_Aggregate_Fields>;
  nodes: Array<Printweb_Background_Material>;
};

export type Printweb_Background_Material_Aggregate_Bool_Exp = {
  count?: InputMaybe<Printweb_Background_Material_Aggregate_Bool_Exp_Count>;
};

export type Printweb_Background_Material_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Printweb_Background_Material_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Printweb_Background_Material_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "printweb.background_material" */
export type Printweb_Background_Material_Aggregate_Fields = {
  __typename?: 'printweb_background_material_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Printweb_Background_Material_Max_Fields>;
  min?: Maybe<Printweb_Background_Material_Min_Fields>;
};


/** aggregate fields of "printweb.background_material" */
export type Printweb_Background_Material_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Printweb_Background_Material_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "printweb.background_material" */
export type Printweb_Background_Material_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Printweb_Background_Material_Max_Order_By>;
  min?: InputMaybe<Printweb_Background_Material_Min_Order_By>;
};

/** input type for inserting array relation for remote table "printweb.background_material" */
export type Printweb_Background_Material_Arr_Rel_Insert_Input = {
  data: Array<Printweb_Background_Material_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Printweb_Background_Material_On_Conflict>;
};

/** Boolean expression to filter rows from the table "printweb.background_material". All fields are combined with a logical 'AND'. */
export type Printweb_Background_Material_Bool_Exp = {
  _and?: InputMaybe<Array<Printweb_Background_Material_Bool_Exp>>;
  _not?: InputMaybe<Printweb_Background_Material_Bool_Exp>;
  _or?: InputMaybe<Array<Printweb_Background_Material_Bool_Exp>>;
  background_material_groups?: InputMaybe<Printweb_Background_Material_Group_Bool_Exp>;
  background_material_groups_aggregate?: InputMaybe<Printweb_Background_Material_Group_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<Bytea_Comparison_Exp>;
  internal_name?: InputMaybe<String_Comparison_Exp>;
  label_id?: InputMaybe<Uuid_Comparison_Exp>;
  material_label?: InputMaybe<Printweb_Material_Label_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "printweb.background_material" */
export enum Printweb_Background_Material_Constraint {
  /** unique or primary key constraint on columns "id" */
  BackgroundMaterialPkey = 'background_material_pkey'
}

/** columns and relationships of "printweb.background_material_group" */
export type Printweb_Background_Material_Group = {
  __typename?: 'printweb_background_material_group';
  /** An object relationship */
  background_material: Printweb_Background_Material;
  background_material_id: Scalars['uuid']['output'];
  /** An object relationship */
  material_group: Printweb_Material_Group;
  material_group_id: Scalars['uuid']['output'];
};

/** aggregated selection of "printweb.background_material_group" */
export type Printweb_Background_Material_Group_Aggregate = {
  __typename?: 'printweb_background_material_group_aggregate';
  aggregate?: Maybe<Printweb_Background_Material_Group_Aggregate_Fields>;
  nodes: Array<Printweb_Background_Material_Group>;
};

export type Printweb_Background_Material_Group_Aggregate_Bool_Exp = {
  count?: InputMaybe<Printweb_Background_Material_Group_Aggregate_Bool_Exp_Count>;
};

export type Printweb_Background_Material_Group_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Printweb_Background_Material_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Printweb_Background_Material_Group_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "printweb.background_material_group" */
export type Printweb_Background_Material_Group_Aggregate_Fields = {
  __typename?: 'printweb_background_material_group_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Printweb_Background_Material_Group_Max_Fields>;
  min?: Maybe<Printweb_Background_Material_Group_Min_Fields>;
};


/** aggregate fields of "printweb.background_material_group" */
export type Printweb_Background_Material_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Printweb_Background_Material_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "printweb.background_material_group" */
export type Printweb_Background_Material_Group_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Printweb_Background_Material_Group_Max_Order_By>;
  min?: InputMaybe<Printweb_Background_Material_Group_Min_Order_By>;
};

/** input type for inserting array relation for remote table "printweb.background_material_group" */
export type Printweb_Background_Material_Group_Arr_Rel_Insert_Input = {
  data: Array<Printweb_Background_Material_Group_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Printweb_Background_Material_Group_On_Conflict>;
};

/** Boolean expression to filter rows from the table "printweb.background_material_group". All fields are combined with a logical 'AND'. */
export type Printweb_Background_Material_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Printweb_Background_Material_Group_Bool_Exp>>;
  _not?: InputMaybe<Printweb_Background_Material_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Printweb_Background_Material_Group_Bool_Exp>>;
  background_material?: InputMaybe<Printweb_Background_Material_Bool_Exp>;
  background_material_id?: InputMaybe<Uuid_Comparison_Exp>;
  material_group?: InputMaybe<Printweb_Material_Group_Bool_Exp>;
  material_group_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "printweb.background_material_group" */
export enum Printweb_Background_Material_Group_Constraint {
  /** unique or primary key constraint on columns "background_material_id", "material_group_id" */
  BackgroundMaterialGroupPkey = 'background_material_group_pkey'
}

/** input type for inserting data into table "printweb.background_material_group" */
export type Printweb_Background_Material_Group_Insert_Input = {
  background_material?: InputMaybe<Printweb_Background_Material_Obj_Rel_Insert_Input>;
  background_material_id?: InputMaybe<Scalars['uuid']['input']>;
  material_group?: InputMaybe<Printweb_Material_Group_Obj_Rel_Insert_Input>;
  material_group_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Printweb_Background_Material_Group_Max_Fields = {
  __typename?: 'printweb_background_material_group_max_fields';
  background_material_id?: Maybe<Scalars['uuid']['output']>;
  material_group_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "printweb.background_material_group" */
export type Printweb_Background_Material_Group_Max_Order_By = {
  background_material_id?: InputMaybe<Order_By>;
  material_group_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Printweb_Background_Material_Group_Min_Fields = {
  __typename?: 'printweb_background_material_group_min_fields';
  background_material_id?: Maybe<Scalars['uuid']['output']>;
  material_group_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "printweb.background_material_group" */
export type Printweb_Background_Material_Group_Min_Order_By = {
  background_material_id?: InputMaybe<Order_By>;
  material_group_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "printweb.background_material_group" */
export type Printweb_Background_Material_Group_Mutation_Response = {
  __typename?: 'printweb_background_material_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Printweb_Background_Material_Group>;
};

/** on_conflict condition type for table "printweb.background_material_group" */
export type Printweb_Background_Material_Group_On_Conflict = {
  constraint: Printweb_Background_Material_Group_Constraint;
  update_columns?: Array<Printweb_Background_Material_Group_Update_Column>;
  where?: InputMaybe<Printweb_Background_Material_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "printweb.background_material_group". */
export type Printweb_Background_Material_Group_Order_By = {
  background_material?: InputMaybe<Printweb_Background_Material_Order_By>;
  background_material_id?: InputMaybe<Order_By>;
  material_group?: InputMaybe<Printweb_Material_Group_Order_By>;
  material_group_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: printweb.background_material_group */
export type Printweb_Background_Material_Group_Pk_Columns_Input = {
  background_material_id: Scalars['uuid']['input'];
  material_group_id: Scalars['uuid']['input'];
};

/** select columns of table "printweb.background_material_group" */
export enum Printweb_Background_Material_Group_Select_Column {
  /** column name */
  BackgroundMaterialId = 'background_material_id',
  /** column name */
  MaterialGroupId = 'material_group_id'
}

/** input type for updating data in table "printweb.background_material_group" */
export type Printweb_Background_Material_Group_Set_Input = {
  background_material_id?: InputMaybe<Scalars['uuid']['input']>;
  material_group_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "printweb_background_material_group" */
export type Printweb_Background_Material_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Printweb_Background_Material_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Printweb_Background_Material_Group_Stream_Cursor_Value_Input = {
  background_material_id?: InputMaybe<Scalars['uuid']['input']>;
  material_group_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "printweb.background_material_group" */
export enum Printweb_Background_Material_Group_Update_Column {
  /** column name */
  BackgroundMaterialId = 'background_material_id',
  /** column name */
  MaterialGroupId = 'material_group_id'
}

export type Printweb_Background_Material_Group_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Printweb_Background_Material_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Printweb_Background_Material_Group_Bool_Exp;
};

/** input type for inserting data into table "printweb.background_material" */
export type Printweb_Background_Material_Insert_Input = {
  background_material_groups?: InputMaybe<Printweb_Background_Material_Group_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['bytea']['input']>;
  internal_name?: InputMaybe<Scalars['String']['input']>;
  label_id?: InputMaybe<Scalars['uuid']['input']>;
  material_label?: InputMaybe<Printweb_Material_Label_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Printweb_Background_Material_Max_Fields = {
  __typename?: 'printweb_background_material_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_name?: Maybe<Scalars['String']['output']>;
  label_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "printweb.background_material" */
export type Printweb_Background_Material_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_name?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Printweb_Background_Material_Min_Fields = {
  __typename?: 'printweb_background_material_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_name?: Maybe<Scalars['String']['output']>;
  label_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "printweb.background_material" */
export type Printweb_Background_Material_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_name?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "printweb.background_material" */
export type Printweb_Background_Material_Mutation_Response = {
  __typename?: 'printweb_background_material_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Printweb_Background_Material>;
};

/** input type for inserting object relation for remote table "printweb.background_material" */
export type Printweb_Background_Material_Obj_Rel_Insert_Input = {
  data: Printweb_Background_Material_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Printweb_Background_Material_On_Conflict>;
};

/** on_conflict condition type for table "printweb.background_material" */
export type Printweb_Background_Material_On_Conflict = {
  constraint: Printweb_Background_Material_Constraint;
  update_columns?: Array<Printweb_Background_Material_Update_Column>;
  where?: InputMaybe<Printweb_Background_Material_Bool_Exp>;
};

/** Ordering options when selecting data from "printweb.background_material". */
export type Printweb_Background_Material_Order_By = {
  background_material_groups_aggregate?: InputMaybe<Printweb_Background_Material_Group_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  internal_name?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
  material_label?: InputMaybe<Printweb_Material_Label_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: printweb.background_material */
export type Printweb_Background_Material_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "printweb.background_material" */
export enum Printweb_Background_Material_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  InternalName = 'internal_name',
  /** column name */
  LabelId = 'label_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "printweb.background_material" */
export type Printweb_Background_Material_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['bytea']['input']>;
  internal_name?: InputMaybe<Scalars['String']['input']>;
  label_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "printweb_background_material" */
export type Printweb_Background_Material_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Printweb_Background_Material_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Printweb_Background_Material_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['bytea']['input']>;
  internal_name?: InputMaybe<Scalars['String']['input']>;
  label_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "printweb.background_material" */
export enum Printweb_Background_Material_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  InternalName = 'internal_name',
  /** column name */
  LabelId = 'label_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Printweb_Background_Material_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Printweb_Background_Material_Set_Input>;
  /** filter the rows which have to be updated */
  where: Printweb_Background_Material_Bool_Exp;
};

/** columns and relationships of "printweb.combinable_spot_colors" */
export type Printweb_Combinable_Spot_Colors = {
  __typename?: 'printweb_combinable_spot_colors';
  combinable_spot_color_id: Scalars['uuid']['output'];
  /** An object relationship */
  spot_color: Printweb_Spot_Color;
  spot_color_id: Scalars['uuid']['output'];
};

/** aggregated selection of "printweb.combinable_spot_colors" */
export type Printweb_Combinable_Spot_Colors_Aggregate = {
  __typename?: 'printweb_combinable_spot_colors_aggregate';
  aggregate?: Maybe<Printweb_Combinable_Spot_Colors_Aggregate_Fields>;
  nodes: Array<Printweb_Combinable_Spot_Colors>;
};

export type Printweb_Combinable_Spot_Colors_Aggregate_Bool_Exp = {
  count?: InputMaybe<Printweb_Combinable_Spot_Colors_Aggregate_Bool_Exp_Count>;
};

export type Printweb_Combinable_Spot_Colors_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Printweb_Combinable_Spot_Colors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Printweb_Combinable_Spot_Colors_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "printweb.combinable_spot_colors" */
export type Printweb_Combinable_Spot_Colors_Aggregate_Fields = {
  __typename?: 'printweb_combinable_spot_colors_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Printweb_Combinable_Spot_Colors_Max_Fields>;
  min?: Maybe<Printweb_Combinable_Spot_Colors_Min_Fields>;
};


/** aggregate fields of "printweb.combinable_spot_colors" */
export type Printweb_Combinable_Spot_Colors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Printweb_Combinable_Spot_Colors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "printweb.combinable_spot_colors" */
export type Printweb_Combinable_Spot_Colors_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Printweb_Combinable_Spot_Colors_Max_Order_By>;
  min?: InputMaybe<Printweb_Combinable_Spot_Colors_Min_Order_By>;
};

/** input type for inserting array relation for remote table "printweb.combinable_spot_colors" */
export type Printweb_Combinable_Spot_Colors_Arr_Rel_Insert_Input = {
  data: Array<Printweb_Combinable_Spot_Colors_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Printweb_Combinable_Spot_Colors_On_Conflict>;
};

/** Boolean expression to filter rows from the table "printweb.combinable_spot_colors". All fields are combined with a logical 'AND'. */
export type Printweb_Combinable_Spot_Colors_Bool_Exp = {
  _and?: InputMaybe<Array<Printweb_Combinable_Spot_Colors_Bool_Exp>>;
  _not?: InputMaybe<Printweb_Combinable_Spot_Colors_Bool_Exp>;
  _or?: InputMaybe<Array<Printweb_Combinable_Spot_Colors_Bool_Exp>>;
  combinable_spot_color_id?: InputMaybe<Uuid_Comparison_Exp>;
  spot_color?: InputMaybe<Printweb_Spot_Color_Bool_Exp>;
  spot_color_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "printweb.combinable_spot_colors" */
export enum Printweb_Combinable_Spot_Colors_Constraint {
  /** unique or primary key constraint on columns "spot_color_id", "combinable_spot_color_id" */
  CombinableSpotColorsPkey = 'combinable_spot_colors_pkey'
}

/** input type for inserting data into table "printweb.combinable_spot_colors" */
export type Printweb_Combinable_Spot_Colors_Insert_Input = {
  combinable_spot_color_id?: InputMaybe<Scalars['uuid']['input']>;
  spot_color?: InputMaybe<Printweb_Spot_Color_Obj_Rel_Insert_Input>;
  spot_color_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Printweb_Combinable_Spot_Colors_Max_Fields = {
  __typename?: 'printweb_combinable_spot_colors_max_fields';
  combinable_spot_color_id?: Maybe<Scalars['uuid']['output']>;
  spot_color_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "printweb.combinable_spot_colors" */
export type Printweb_Combinable_Spot_Colors_Max_Order_By = {
  combinable_spot_color_id?: InputMaybe<Order_By>;
  spot_color_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Printweb_Combinable_Spot_Colors_Min_Fields = {
  __typename?: 'printweb_combinable_spot_colors_min_fields';
  combinable_spot_color_id?: Maybe<Scalars['uuid']['output']>;
  spot_color_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "printweb.combinable_spot_colors" */
export type Printweb_Combinable_Spot_Colors_Min_Order_By = {
  combinable_spot_color_id?: InputMaybe<Order_By>;
  spot_color_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "printweb.combinable_spot_colors" */
export type Printweb_Combinable_Spot_Colors_Mutation_Response = {
  __typename?: 'printweb_combinable_spot_colors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Printweb_Combinable_Spot_Colors>;
};

/** on_conflict condition type for table "printweb.combinable_spot_colors" */
export type Printweb_Combinable_Spot_Colors_On_Conflict = {
  constraint: Printweb_Combinable_Spot_Colors_Constraint;
  update_columns?: Array<Printweb_Combinable_Spot_Colors_Update_Column>;
  where?: InputMaybe<Printweb_Combinable_Spot_Colors_Bool_Exp>;
};

/** Ordering options when selecting data from "printweb.combinable_spot_colors". */
export type Printweb_Combinable_Spot_Colors_Order_By = {
  combinable_spot_color_id?: InputMaybe<Order_By>;
  spot_color?: InputMaybe<Printweb_Spot_Color_Order_By>;
  spot_color_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: printweb.combinable_spot_colors */
export type Printweb_Combinable_Spot_Colors_Pk_Columns_Input = {
  combinable_spot_color_id: Scalars['uuid']['input'];
  spot_color_id: Scalars['uuid']['input'];
};

/** select columns of table "printweb.combinable_spot_colors" */
export enum Printweb_Combinable_Spot_Colors_Select_Column {
  /** column name */
  CombinableSpotColorId = 'combinable_spot_color_id',
  /** column name */
  SpotColorId = 'spot_color_id'
}

/** input type for updating data in table "printweb.combinable_spot_colors" */
export type Printweb_Combinable_Spot_Colors_Set_Input = {
  combinable_spot_color_id?: InputMaybe<Scalars['uuid']['input']>;
  spot_color_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "printweb_combinable_spot_colors" */
export type Printweb_Combinable_Spot_Colors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Printweb_Combinable_Spot_Colors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Printweb_Combinable_Spot_Colors_Stream_Cursor_Value_Input = {
  combinable_spot_color_id?: InputMaybe<Scalars['uuid']['input']>;
  spot_color_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "printweb.combinable_spot_colors" */
export enum Printweb_Combinable_Spot_Colors_Update_Column {
  /** column name */
  CombinableSpotColorId = 'combinable_spot_color_id',
  /** column name */
  SpotColorId = 'spot_color_id'
}

export type Printweb_Combinable_Spot_Colors_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Printweb_Combinable_Spot_Colors_Set_Input>;
  /** filter the rows which have to be updated */
  where: Printweb_Combinable_Spot_Colors_Bool_Exp;
};

/** deployments of the printweb application */
export type Printweb_Instance = {
  __typename?: 'printweb_instance';
  allowed_url?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  background_materials: Array<Printweb_Instance_Background_Material>;
  /** An aggregate relationship */
  background_materials_aggregate: Printweb_Instance_Background_Material_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  header_logo: Scalars['bytea']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  spot_colors: Array<Printweb_Instance_Spot_Color>;
  /** An aggregate relationship */
  spot_colors_aggregate: Printweb_Instance_Spot_Color_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
};


/** deployments of the printweb application */
export type Printweb_InstanceBackground_MaterialsArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Instance_Background_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Instance_Background_Material_Order_By>>;
  where?: InputMaybe<Printweb_Instance_Background_Material_Bool_Exp>;
};


/** deployments of the printweb application */
export type Printweb_InstanceBackground_Materials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Instance_Background_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Instance_Background_Material_Order_By>>;
  where?: InputMaybe<Printweb_Instance_Background_Material_Bool_Exp>;
};


/** deployments of the printweb application */
export type Printweb_InstanceSpot_ColorsArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Instance_Spot_Color_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Instance_Spot_Color_Order_By>>;
  where?: InputMaybe<Printweb_Instance_Spot_Color_Bool_Exp>;
};


/** deployments of the printweb application */
export type Printweb_InstanceSpot_Colors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Instance_Spot_Color_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Instance_Spot_Color_Order_By>>;
  where?: InputMaybe<Printweb_Instance_Spot_Color_Bool_Exp>;
};

/** aggregated selection of "printweb.instance" */
export type Printweb_Instance_Aggregate = {
  __typename?: 'printweb_instance_aggregate';
  aggregate?: Maybe<Printweb_Instance_Aggregate_Fields>;
  nodes: Array<Printweb_Instance>;
};

/** aggregate fields of "printweb.instance" */
export type Printweb_Instance_Aggregate_Fields = {
  __typename?: 'printweb_instance_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Printweb_Instance_Max_Fields>;
  min?: Maybe<Printweb_Instance_Min_Fields>;
};


/** aggregate fields of "printweb.instance" */
export type Printweb_Instance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Printweb_Instance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "printweb.instance_background_material" */
export type Printweb_Instance_Background_Material = {
  __typename?: 'printweb_instance_background_material';
  /** An object relationship */
  background_material: Printweb_Background_Material;
  background_material_id: Scalars['uuid']['output'];
  instance_id: Scalars['uuid']['output'];
};

/** aggregated selection of "printweb.instance_background_material" */
export type Printweb_Instance_Background_Material_Aggregate = {
  __typename?: 'printweb_instance_background_material_aggregate';
  aggregate?: Maybe<Printweb_Instance_Background_Material_Aggregate_Fields>;
  nodes: Array<Printweb_Instance_Background_Material>;
};

export type Printweb_Instance_Background_Material_Aggregate_Bool_Exp = {
  count?: InputMaybe<Printweb_Instance_Background_Material_Aggregate_Bool_Exp_Count>;
};

export type Printweb_Instance_Background_Material_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Printweb_Instance_Background_Material_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Printweb_Instance_Background_Material_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "printweb.instance_background_material" */
export type Printweb_Instance_Background_Material_Aggregate_Fields = {
  __typename?: 'printweb_instance_background_material_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Printweb_Instance_Background_Material_Max_Fields>;
  min?: Maybe<Printweb_Instance_Background_Material_Min_Fields>;
};


/** aggregate fields of "printweb.instance_background_material" */
export type Printweb_Instance_Background_Material_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Printweb_Instance_Background_Material_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "printweb.instance_background_material" */
export type Printweb_Instance_Background_Material_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Printweb_Instance_Background_Material_Max_Order_By>;
  min?: InputMaybe<Printweb_Instance_Background_Material_Min_Order_By>;
};

/** input type for inserting array relation for remote table "printweb.instance_background_material" */
export type Printweb_Instance_Background_Material_Arr_Rel_Insert_Input = {
  data: Array<Printweb_Instance_Background_Material_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Printweb_Instance_Background_Material_On_Conflict>;
};

/** Boolean expression to filter rows from the table "printweb.instance_background_material". All fields are combined with a logical 'AND'. */
export type Printweb_Instance_Background_Material_Bool_Exp = {
  _and?: InputMaybe<Array<Printweb_Instance_Background_Material_Bool_Exp>>;
  _not?: InputMaybe<Printweb_Instance_Background_Material_Bool_Exp>;
  _or?: InputMaybe<Array<Printweb_Instance_Background_Material_Bool_Exp>>;
  background_material?: InputMaybe<Printweb_Background_Material_Bool_Exp>;
  background_material_id?: InputMaybe<Uuid_Comparison_Exp>;
  instance_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "printweb.instance_background_material" */
export enum Printweb_Instance_Background_Material_Constraint {
  /** unique or primary key constraint on columns "background_material_id", "instance_id" */
  InstanceBackgroundMaterialPkey = 'instance_background_material_pkey'
}

/** input type for inserting data into table "printweb.instance_background_material" */
export type Printweb_Instance_Background_Material_Insert_Input = {
  background_material?: InputMaybe<Printweb_Background_Material_Obj_Rel_Insert_Input>;
  background_material_id?: InputMaybe<Scalars['uuid']['input']>;
  instance_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Printweb_Instance_Background_Material_Max_Fields = {
  __typename?: 'printweb_instance_background_material_max_fields';
  background_material_id?: Maybe<Scalars['uuid']['output']>;
  instance_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "printweb.instance_background_material" */
export type Printweb_Instance_Background_Material_Max_Order_By = {
  background_material_id?: InputMaybe<Order_By>;
  instance_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Printweb_Instance_Background_Material_Min_Fields = {
  __typename?: 'printweb_instance_background_material_min_fields';
  background_material_id?: Maybe<Scalars['uuid']['output']>;
  instance_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "printweb.instance_background_material" */
export type Printweb_Instance_Background_Material_Min_Order_By = {
  background_material_id?: InputMaybe<Order_By>;
  instance_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "printweb.instance_background_material" */
export type Printweb_Instance_Background_Material_Mutation_Response = {
  __typename?: 'printweb_instance_background_material_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Printweb_Instance_Background_Material>;
};

/** on_conflict condition type for table "printweb.instance_background_material" */
export type Printweb_Instance_Background_Material_On_Conflict = {
  constraint: Printweb_Instance_Background_Material_Constraint;
  update_columns?: Array<Printweb_Instance_Background_Material_Update_Column>;
  where?: InputMaybe<Printweb_Instance_Background_Material_Bool_Exp>;
};

/** Ordering options when selecting data from "printweb.instance_background_material". */
export type Printweb_Instance_Background_Material_Order_By = {
  background_material?: InputMaybe<Printweb_Background_Material_Order_By>;
  background_material_id?: InputMaybe<Order_By>;
  instance_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: printweb.instance_background_material */
export type Printweb_Instance_Background_Material_Pk_Columns_Input = {
  background_material_id: Scalars['uuid']['input'];
  instance_id: Scalars['uuid']['input'];
};

/** select columns of table "printweb.instance_background_material" */
export enum Printweb_Instance_Background_Material_Select_Column {
  /** column name */
  BackgroundMaterialId = 'background_material_id',
  /** column name */
  InstanceId = 'instance_id'
}

/** input type for updating data in table "printweb.instance_background_material" */
export type Printweb_Instance_Background_Material_Set_Input = {
  background_material_id?: InputMaybe<Scalars['uuid']['input']>;
  instance_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "printweb_instance_background_material" */
export type Printweb_Instance_Background_Material_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Printweb_Instance_Background_Material_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Printweb_Instance_Background_Material_Stream_Cursor_Value_Input = {
  background_material_id?: InputMaybe<Scalars['uuid']['input']>;
  instance_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "printweb.instance_background_material" */
export enum Printweb_Instance_Background_Material_Update_Column {
  /** column name */
  BackgroundMaterialId = 'background_material_id',
  /** column name */
  InstanceId = 'instance_id'
}

export type Printweb_Instance_Background_Material_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Printweb_Instance_Background_Material_Set_Input>;
  /** filter the rows which have to be updated */
  where: Printweb_Instance_Background_Material_Bool_Exp;
};

/** Boolean expression to filter rows from the table "printweb.instance". All fields are combined with a logical 'AND'. */
export type Printweb_Instance_Bool_Exp = {
  _and?: InputMaybe<Array<Printweb_Instance_Bool_Exp>>;
  _not?: InputMaybe<Printweb_Instance_Bool_Exp>;
  _or?: InputMaybe<Array<Printweb_Instance_Bool_Exp>>;
  allowed_url?: InputMaybe<String_Comparison_Exp>;
  background_materials?: InputMaybe<Printweb_Instance_Background_Material_Bool_Exp>;
  background_materials_aggregate?: InputMaybe<Printweb_Instance_Background_Material_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  header_logo?: InputMaybe<Bytea_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  spot_colors?: InputMaybe<Printweb_Instance_Spot_Color_Bool_Exp>;
  spot_colors_aggregate?: InputMaybe<Printweb_Instance_Spot_Color_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "printweb.instance" */
export enum Printweb_Instance_Constraint {
  /** unique or primary key constraint on columns "id" */
  InstancePkey = 'instance_pkey'
}

/** input type for inserting data into table "printweb.instance" */
export type Printweb_Instance_Insert_Input = {
  allowed_url?: InputMaybe<Scalars['String']['input']>;
  background_materials?: InputMaybe<Printweb_Instance_Background_Material_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  header_logo?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  spot_colors?: InputMaybe<Printweb_Instance_Spot_Color_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Printweb_Instance_Max_Fields = {
  __typename?: 'printweb_instance_max_fields';
  allowed_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Printweb_Instance_Min_Fields = {
  __typename?: 'printweb_instance_min_fields';
  allowed_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "printweb.instance" */
export type Printweb_Instance_Mutation_Response = {
  __typename?: 'printweb_instance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Printweb_Instance>;
};

/** on_conflict condition type for table "printweb.instance" */
export type Printweb_Instance_On_Conflict = {
  constraint: Printweb_Instance_Constraint;
  update_columns?: Array<Printweb_Instance_Update_Column>;
  where?: InputMaybe<Printweb_Instance_Bool_Exp>;
};

/** Ordering options when selecting data from "printweb.instance". */
export type Printweb_Instance_Order_By = {
  allowed_url?: InputMaybe<Order_By>;
  background_materials_aggregate?: InputMaybe<Printweb_Instance_Background_Material_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  header_logo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  spot_colors_aggregate?: InputMaybe<Printweb_Instance_Spot_Color_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: printweb.instance */
export type Printweb_Instance_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "printweb.instance" */
export enum Printweb_Instance_Select_Column {
  /** column name */
  AllowedUrl = 'allowed_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HeaderLogo = 'header_logo',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "printweb.instance" */
export type Printweb_Instance_Set_Input = {
  allowed_url?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  header_logo?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "printweb.instance_spot_color" */
export type Printweb_Instance_Spot_Color = {
  __typename?: 'printweb_instance_spot_color';
  instance_id: Scalars['uuid']['output'];
  /** An object relationship */
  spot_color: Printweb_Spot_Color;
  spot_color_id: Scalars['uuid']['output'];
};

/** aggregated selection of "printweb.instance_spot_color" */
export type Printweb_Instance_Spot_Color_Aggregate = {
  __typename?: 'printweb_instance_spot_color_aggregate';
  aggregate?: Maybe<Printweb_Instance_Spot_Color_Aggregate_Fields>;
  nodes: Array<Printweb_Instance_Spot_Color>;
};

export type Printweb_Instance_Spot_Color_Aggregate_Bool_Exp = {
  count?: InputMaybe<Printweb_Instance_Spot_Color_Aggregate_Bool_Exp_Count>;
};

export type Printweb_Instance_Spot_Color_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Printweb_Instance_Spot_Color_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Printweb_Instance_Spot_Color_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "printweb.instance_spot_color" */
export type Printweb_Instance_Spot_Color_Aggregate_Fields = {
  __typename?: 'printweb_instance_spot_color_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Printweb_Instance_Spot_Color_Max_Fields>;
  min?: Maybe<Printweb_Instance_Spot_Color_Min_Fields>;
};


/** aggregate fields of "printweb.instance_spot_color" */
export type Printweb_Instance_Spot_Color_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Printweb_Instance_Spot_Color_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "printweb.instance_spot_color" */
export type Printweb_Instance_Spot_Color_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Printweb_Instance_Spot_Color_Max_Order_By>;
  min?: InputMaybe<Printweb_Instance_Spot_Color_Min_Order_By>;
};

/** input type for inserting array relation for remote table "printweb.instance_spot_color" */
export type Printweb_Instance_Spot_Color_Arr_Rel_Insert_Input = {
  data: Array<Printweb_Instance_Spot_Color_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Printweb_Instance_Spot_Color_On_Conflict>;
};

/** Boolean expression to filter rows from the table "printweb.instance_spot_color". All fields are combined with a logical 'AND'. */
export type Printweb_Instance_Spot_Color_Bool_Exp = {
  _and?: InputMaybe<Array<Printweb_Instance_Spot_Color_Bool_Exp>>;
  _not?: InputMaybe<Printweb_Instance_Spot_Color_Bool_Exp>;
  _or?: InputMaybe<Array<Printweb_Instance_Spot_Color_Bool_Exp>>;
  instance_id?: InputMaybe<Uuid_Comparison_Exp>;
  spot_color?: InputMaybe<Printweb_Spot_Color_Bool_Exp>;
  spot_color_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "printweb.instance_spot_color" */
export enum Printweb_Instance_Spot_Color_Constraint {
  /** unique or primary key constraint on columns "spot_color_id", "instance_id" */
  InstanceSpotColorPkey = 'instance_spot_color_pkey'
}

/** input type for inserting data into table "printweb.instance_spot_color" */
export type Printweb_Instance_Spot_Color_Insert_Input = {
  instance_id?: InputMaybe<Scalars['uuid']['input']>;
  spot_color?: InputMaybe<Printweb_Spot_Color_Obj_Rel_Insert_Input>;
  spot_color_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Printweb_Instance_Spot_Color_Max_Fields = {
  __typename?: 'printweb_instance_spot_color_max_fields';
  instance_id?: Maybe<Scalars['uuid']['output']>;
  spot_color_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "printweb.instance_spot_color" */
export type Printweb_Instance_Spot_Color_Max_Order_By = {
  instance_id?: InputMaybe<Order_By>;
  spot_color_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Printweb_Instance_Spot_Color_Min_Fields = {
  __typename?: 'printweb_instance_spot_color_min_fields';
  instance_id?: Maybe<Scalars['uuid']['output']>;
  spot_color_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "printweb.instance_spot_color" */
export type Printweb_Instance_Spot_Color_Min_Order_By = {
  instance_id?: InputMaybe<Order_By>;
  spot_color_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "printweb.instance_spot_color" */
export type Printweb_Instance_Spot_Color_Mutation_Response = {
  __typename?: 'printweb_instance_spot_color_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Printweb_Instance_Spot_Color>;
};

/** on_conflict condition type for table "printweb.instance_spot_color" */
export type Printweb_Instance_Spot_Color_On_Conflict = {
  constraint: Printweb_Instance_Spot_Color_Constraint;
  update_columns?: Array<Printweb_Instance_Spot_Color_Update_Column>;
  where?: InputMaybe<Printweb_Instance_Spot_Color_Bool_Exp>;
};

/** Ordering options when selecting data from "printweb.instance_spot_color". */
export type Printweb_Instance_Spot_Color_Order_By = {
  instance_id?: InputMaybe<Order_By>;
  spot_color?: InputMaybe<Printweb_Spot_Color_Order_By>;
  spot_color_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: printweb.instance_spot_color */
export type Printweb_Instance_Spot_Color_Pk_Columns_Input = {
  instance_id: Scalars['uuid']['input'];
  spot_color_id: Scalars['uuid']['input'];
};

/** select columns of table "printweb.instance_spot_color" */
export enum Printweb_Instance_Spot_Color_Select_Column {
  /** column name */
  InstanceId = 'instance_id',
  /** column name */
  SpotColorId = 'spot_color_id'
}

/** input type for updating data in table "printweb.instance_spot_color" */
export type Printweb_Instance_Spot_Color_Set_Input = {
  instance_id?: InputMaybe<Scalars['uuid']['input']>;
  spot_color_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "printweb_instance_spot_color" */
export type Printweb_Instance_Spot_Color_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Printweb_Instance_Spot_Color_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Printweb_Instance_Spot_Color_Stream_Cursor_Value_Input = {
  instance_id?: InputMaybe<Scalars['uuid']['input']>;
  spot_color_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "printweb.instance_spot_color" */
export enum Printweb_Instance_Spot_Color_Update_Column {
  /** column name */
  InstanceId = 'instance_id',
  /** column name */
  SpotColorId = 'spot_color_id'
}

export type Printweb_Instance_Spot_Color_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Printweb_Instance_Spot_Color_Set_Input>;
  /** filter the rows which have to be updated */
  where: Printweb_Instance_Spot_Color_Bool_Exp;
};

/** Streaming cursor of the table "printweb_instance" */
export type Printweb_Instance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Printweb_Instance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Printweb_Instance_Stream_Cursor_Value_Input = {
  allowed_url?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  header_logo?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "printweb.instance" */
export enum Printweb_Instance_Update_Column {
  /** column name */
  AllowedUrl = 'allowed_url',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HeaderLogo = 'header_logo',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Printweb_Instance_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Printweb_Instance_Set_Input>;
  /** filter the rows which have to be updated */
  where: Printweb_Instance_Bool_Exp;
};

/** columns and relationships of "printweb.material_group" */
export type Printweb_Material_Group = {
  __typename?: 'printweb_material_group';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  material_group_background_materials: Array<Printweb_Background_Material_Group>;
  /** An aggregate relationship */
  material_group_background_materials_aggregate: Printweb_Background_Material_Group_Aggregate;
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "printweb.material_group" */
export type Printweb_Material_GroupMaterial_Group_Background_MaterialsArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Background_Material_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Background_Material_Group_Order_By>>;
  where?: InputMaybe<Printweb_Background_Material_Group_Bool_Exp>;
};


/** columns and relationships of "printweb.material_group" */
export type Printweb_Material_GroupMaterial_Group_Background_Materials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Background_Material_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Background_Material_Group_Order_By>>;
  where?: InputMaybe<Printweb_Background_Material_Group_Bool_Exp>;
};

/** aggregated selection of "printweb.material_group" */
export type Printweb_Material_Group_Aggregate = {
  __typename?: 'printweb_material_group_aggregate';
  aggregate?: Maybe<Printweb_Material_Group_Aggregate_Fields>;
  nodes: Array<Printweb_Material_Group>;
};

/** aggregate fields of "printweb.material_group" */
export type Printweb_Material_Group_Aggregate_Fields = {
  __typename?: 'printweb_material_group_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Printweb_Material_Group_Max_Fields>;
  min?: Maybe<Printweb_Material_Group_Min_Fields>;
};


/** aggregate fields of "printweb.material_group" */
export type Printweb_Material_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Printweb_Material_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "printweb.material_group". All fields are combined with a logical 'AND'. */
export type Printweb_Material_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Printweb_Material_Group_Bool_Exp>>;
  _not?: InputMaybe<Printweb_Material_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Printweb_Material_Group_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  material_group_background_materials?: InputMaybe<Printweb_Background_Material_Group_Bool_Exp>;
  material_group_background_materials_aggregate?: InputMaybe<Printweb_Background_Material_Group_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "printweb.material_group" */
export enum Printweb_Material_Group_Constraint {
  /** unique or primary key constraint on columns "id" */
  MaterialGroupPkey = 'material_group_pkey'
}

/** input type for inserting data into table "printweb.material_group" */
export type Printweb_Material_Group_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  material_group_background_materials?: InputMaybe<Printweb_Background_Material_Group_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Printweb_Material_Group_Max_Fields = {
  __typename?: 'printweb_material_group_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Printweb_Material_Group_Min_Fields = {
  __typename?: 'printweb_material_group_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "printweb.material_group" */
export type Printweb_Material_Group_Mutation_Response = {
  __typename?: 'printweb_material_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Printweb_Material_Group>;
};

/** input type for inserting object relation for remote table "printweb.material_group" */
export type Printweb_Material_Group_Obj_Rel_Insert_Input = {
  data: Printweb_Material_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Printweb_Material_Group_On_Conflict>;
};

/** on_conflict condition type for table "printweb.material_group" */
export type Printweb_Material_Group_On_Conflict = {
  constraint: Printweb_Material_Group_Constraint;
  update_columns?: Array<Printweb_Material_Group_Update_Column>;
  where?: InputMaybe<Printweb_Material_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "printweb.material_group". */
export type Printweb_Material_Group_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  material_group_background_materials_aggregate?: InputMaybe<Printweb_Background_Material_Group_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: printweb.material_group */
export type Printweb_Material_Group_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "printweb.material_group" */
export enum Printweb_Material_Group_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "printweb.material_group" */
export type Printweb_Material_Group_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "printweb_material_group" */
export type Printweb_Material_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Printweb_Material_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Printweb_Material_Group_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "printweb.material_group" */
export enum Printweb_Material_Group_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Printweb_Material_Group_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Printweb_Material_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Printweb_Material_Group_Bool_Exp;
};

/** columns and relationships of "printweb.material_label" */
export type Printweb_Material_Label = {
  __typename?: 'printweb_material_label';
  /** An array relationship */
  background_materials: Array<Printweb_Background_Material>;
  /** An aggregate relationship */
  background_materials_aggregate: Printweb_Background_Material_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "printweb.material_label" */
export type Printweb_Material_LabelBackground_MaterialsArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Background_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Background_Material_Order_By>>;
  where?: InputMaybe<Printweb_Background_Material_Bool_Exp>;
};


/** columns and relationships of "printweb.material_label" */
export type Printweb_Material_LabelBackground_Materials_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Background_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Background_Material_Order_By>>;
  where?: InputMaybe<Printweb_Background_Material_Bool_Exp>;
};

/** aggregated selection of "printweb.material_label" */
export type Printweb_Material_Label_Aggregate = {
  __typename?: 'printweb_material_label_aggregate';
  aggregate?: Maybe<Printweb_Material_Label_Aggregate_Fields>;
  nodes: Array<Printweb_Material_Label>;
};

/** aggregate fields of "printweb.material_label" */
export type Printweb_Material_Label_Aggregate_Fields = {
  __typename?: 'printweb_material_label_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Printweb_Material_Label_Max_Fields>;
  min?: Maybe<Printweb_Material_Label_Min_Fields>;
};


/** aggregate fields of "printweb.material_label" */
export type Printweb_Material_Label_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Printweb_Material_Label_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "printweb.material_label". All fields are combined with a logical 'AND'. */
export type Printweb_Material_Label_Bool_Exp = {
  _and?: InputMaybe<Array<Printweb_Material_Label_Bool_Exp>>;
  _not?: InputMaybe<Printweb_Material_Label_Bool_Exp>;
  _or?: InputMaybe<Array<Printweb_Material_Label_Bool_Exp>>;
  background_materials?: InputMaybe<Printweb_Background_Material_Bool_Exp>;
  background_materials_aggregate?: InputMaybe<Printweb_Background_Material_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "printweb.material_label" */
export enum Printweb_Material_Label_Constraint {
  /** unique or primary key constraint on columns "id" */
  MaterialLabelPkey = 'material_label_pkey'
}

/** input type for inserting data into table "printweb.material_label" */
export type Printweb_Material_Label_Insert_Input = {
  background_materials?: InputMaybe<Printweb_Background_Material_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Printweb_Material_Label_Max_Fields = {
  __typename?: 'printweb_material_label_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Printweb_Material_Label_Min_Fields = {
  __typename?: 'printweb_material_label_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "printweb.material_label" */
export type Printweb_Material_Label_Mutation_Response = {
  __typename?: 'printweb_material_label_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Printweb_Material_Label>;
};

/** input type for inserting object relation for remote table "printweb.material_label" */
export type Printweb_Material_Label_Obj_Rel_Insert_Input = {
  data: Printweb_Material_Label_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Printweb_Material_Label_On_Conflict>;
};

/** on_conflict condition type for table "printweb.material_label" */
export type Printweb_Material_Label_On_Conflict = {
  constraint: Printweb_Material_Label_Constraint;
  update_columns?: Array<Printweb_Material_Label_Update_Column>;
  where?: InputMaybe<Printweb_Material_Label_Bool_Exp>;
};

/** Ordering options when selecting data from "printweb.material_label". */
export type Printweb_Material_Label_Order_By = {
  background_materials_aggregate?: InputMaybe<Printweb_Background_Material_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: printweb.material_label */
export type Printweb_Material_Label_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "printweb.material_label" */
export enum Printweb_Material_Label_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "printweb.material_label" */
export type Printweb_Material_Label_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "printweb_material_label" */
export type Printweb_Material_Label_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Printweb_Material_Label_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Printweb_Material_Label_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "printweb.material_label" */
export enum Printweb_Material_Label_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Printweb_Material_Label_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Printweb_Material_Label_Set_Input>;
  /** filter the rows which have to be updated */
  where: Printweb_Material_Label_Bool_Exp;
};

/** columns and relationships of "printweb.spot_color" */
export type Printweb_Spot_Color = {
  __typename?: 'printweb_spot_color';
  /** An array relationship */
  combinable_colors: Array<Printweb_Combinable_Spot_Colors>;
  /** An aggregate relationship */
  combinable_colors_aggregate: Printweb_Combinable_Spot_Colors_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  display_name: Scalars['String']['output'];
  do_overprint: Scalars['Boolean']['output'];
  fill_allowed: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  image: Scalars['bytea']['output'];
  internal_name: Scalars['String']['output'];
  line_width?: Maybe<Scalars['numeric']['output']>;
  max_intensity: Scalars['numeric']['output'];
  min_intensity: Scalars['numeric']['output'];
  mixing_allowed?: Maybe<Scalars['Boolean']['output']>;
  overprint_mode: Scalars['Boolean']['output'];
  stroke_allowed: Scalars['Boolean']['output'];
  technical_name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "printweb.spot_color" */
export type Printweb_Spot_ColorCombinable_ColorsArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Combinable_Spot_Colors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Combinable_Spot_Colors_Order_By>>;
  where?: InputMaybe<Printweb_Combinable_Spot_Colors_Bool_Exp>;
};


/** columns and relationships of "printweb.spot_color" */
export type Printweb_Spot_ColorCombinable_Colors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Combinable_Spot_Colors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Combinable_Spot_Colors_Order_By>>;
  where?: InputMaybe<Printweb_Combinable_Spot_Colors_Bool_Exp>;
};

/** aggregated selection of "printweb.spot_color" */
export type Printweb_Spot_Color_Aggregate = {
  __typename?: 'printweb_spot_color_aggregate';
  aggregate?: Maybe<Printweb_Spot_Color_Aggregate_Fields>;
  nodes: Array<Printweb_Spot_Color>;
};

/** aggregate fields of "printweb.spot_color" */
export type Printweb_Spot_Color_Aggregate_Fields = {
  __typename?: 'printweb_spot_color_aggregate_fields';
  avg?: Maybe<Printweb_Spot_Color_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Printweb_Spot_Color_Max_Fields>;
  min?: Maybe<Printweb_Spot_Color_Min_Fields>;
  stddev?: Maybe<Printweb_Spot_Color_Stddev_Fields>;
  stddev_pop?: Maybe<Printweb_Spot_Color_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Printweb_Spot_Color_Stddev_Samp_Fields>;
  sum?: Maybe<Printweb_Spot_Color_Sum_Fields>;
  var_pop?: Maybe<Printweb_Spot_Color_Var_Pop_Fields>;
  var_samp?: Maybe<Printweb_Spot_Color_Var_Samp_Fields>;
  variance?: Maybe<Printweb_Spot_Color_Variance_Fields>;
};


/** aggregate fields of "printweb.spot_color" */
export type Printweb_Spot_Color_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Printweb_Spot_Color_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Printweb_Spot_Color_Avg_Fields = {
  __typename?: 'printweb_spot_color_avg_fields';
  line_width?: Maybe<Scalars['Float']['output']>;
  max_intensity?: Maybe<Scalars['Float']['output']>;
  min_intensity?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "printweb.spot_color". All fields are combined with a logical 'AND'. */
export type Printweb_Spot_Color_Bool_Exp = {
  _and?: InputMaybe<Array<Printweb_Spot_Color_Bool_Exp>>;
  _not?: InputMaybe<Printweb_Spot_Color_Bool_Exp>;
  _or?: InputMaybe<Array<Printweb_Spot_Color_Bool_Exp>>;
  combinable_colors?: InputMaybe<Printweb_Combinable_Spot_Colors_Bool_Exp>;
  combinable_colors_aggregate?: InputMaybe<Printweb_Combinable_Spot_Colors_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  do_overprint?: InputMaybe<Boolean_Comparison_Exp>;
  fill_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<Bytea_Comparison_Exp>;
  internal_name?: InputMaybe<String_Comparison_Exp>;
  line_width?: InputMaybe<Numeric_Comparison_Exp>;
  max_intensity?: InputMaybe<Numeric_Comparison_Exp>;
  min_intensity?: InputMaybe<Numeric_Comparison_Exp>;
  mixing_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  overprint_mode?: InputMaybe<Boolean_Comparison_Exp>;
  stroke_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  technical_name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "printweb.spot_color" */
export enum Printweb_Spot_Color_Constraint {
  /** unique or primary key constraint on columns "id" */
  SpotColorPkey = 'spot_color_pkey'
}

/** input type for incrementing numeric columns in table "printweb.spot_color" */
export type Printweb_Spot_Color_Inc_Input = {
  line_width?: InputMaybe<Scalars['numeric']['input']>;
  max_intensity?: InputMaybe<Scalars['numeric']['input']>;
  min_intensity?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "printweb.spot_color" */
export type Printweb_Spot_Color_Insert_Input = {
  combinable_colors?: InputMaybe<Printweb_Combinable_Spot_Colors_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  do_overprint?: InputMaybe<Scalars['Boolean']['input']>;
  fill_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['bytea']['input']>;
  internal_name?: InputMaybe<Scalars['String']['input']>;
  line_width?: InputMaybe<Scalars['numeric']['input']>;
  max_intensity?: InputMaybe<Scalars['numeric']['input']>;
  min_intensity?: InputMaybe<Scalars['numeric']['input']>;
  mixing_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  overprint_mode?: InputMaybe<Scalars['Boolean']['input']>;
  stroke_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  technical_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Printweb_Spot_Color_Max_Fields = {
  __typename?: 'printweb_spot_color_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_name?: Maybe<Scalars['String']['output']>;
  line_width?: Maybe<Scalars['numeric']['output']>;
  max_intensity?: Maybe<Scalars['numeric']['output']>;
  min_intensity?: Maybe<Scalars['numeric']['output']>;
  technical_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Printweb_Spot_Color_Min_Fields = {
  __typename?: 'printweb_spot_color_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_name?: Maybe<Scalars['String']['output']>;
  line_width?: Maybe<Scalars['numeric']['output']>;
  max_intensity?: Maybe<Scalars['numeric']['output']>;
  min_intensity?: Maybe<Scalars['numeric']['output']>;
  technical_name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "printweb.spot_color" */
export type Printweb_Spot_Color_Mutation_Response = {
  __typename?: 'printweb_spot_color_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Printweb_Spot_Color>;
};

/** input type for inserting object relation for remote table "printweb.spot_color" */
export type Printweb_Spot_Color_Obj_Rel_Insert_Input = {
  data: Printweb_Spot_Color_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Printweb_Spot_Color_On_Conflict>;
};

/** on_conflict condition type for table "printweb.spot_color" */
export type Printweb_Spot_Color_On_Conflict = {
  constraint: Printweb_Spot_Color_Constraint;
  update_columns?: Array<Printweb_Spot_Color_Update_Column>;
  where?: InputMaybe<Printweb_Spot_Color_Bool_Exp>;
};

/** Ordering options when selecting data from "printweb.spot_color". */
export type Printweb_Spot_Color_Order_By = {
  combinable_colors_aggregate?: InputMaybe<Printweb_Combinable_Spot_Colors_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  do_overprint?: InputMaybe<Order_By>;
  fill_allowed?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Order_By>;
  internal_name?: InputMaybe<Order_By>;
  line_width?: InputMaybe<Order_By>;
  max_intensity?: InputMaybe<Order_By>;
  min_intensity?: InputMaybe<Order_By>;
  mixing_allowed?: InputMaybe<Order_By>;
  overprint_mode?: InputMaybe<Order_By>;
  stroke_allowed?: InputMaybe<Order_By>;
  technical_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: printweb.spot_color */
export type Printweb_Spot_Color_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "printweb.spot_color" */
export enum Printweb_Spot_Color_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DoOverprint = 'do_overprint',
  /** column name */
  FillAllowed = 'fill_allowed',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  InternalName = 'internal_name',
  /** column name */
  LineWidth = 'line_width',
  /** column name */
  MaxIntensity = 'max_intensity',
  /** column name */
  MinIntensity = 'min_intensity',
  /** column name */
  MixingAllowed = 'mixing_allowed',
  /** column name */
  OverprintMode = 'overprint_mode',
  /** column name */
  StrokeAllowed = 'stroke_allowed',
  /** column name */
  TechnicalName = 'technical_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "printweb.spot_color" */
export type Printweb_Spot_Color_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  do_overprint?: InputMaybe<Scalars['Boolean']['input']>;
  fill_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['bytea']['input']>;
  internal_name?: InputMaybe<Scalars['String']['input']>;
  line_width?: InputMaybe<Scalars['numeric']['input']>;
  max_intensity?: InputMaybe<Scalars['numeric']['input']>;
  min_intensity?: InputMaybe<Scalars['numeric']['input']>;
  mixing_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  overprint_mode?: InputMaybe<Scalars['Boolean']['input']>;
  stroke_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  technical_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Printweb_Spot_Color_Stddev_Fields = {
  __typename?: 'printweb_spot_color_stddev_fields';
  line_width?: Maybe<Scalars['Float']['output']>;
  max_intensity?: Maybe<Scalars['Float']['output']>;
  min_intensity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Printweb_Spot_Color_Stddev_Pop_Fields = {
  __typename?: 'printweb_spot_color_stddev_pop_fields';
  line_width?: Maybe<Scalars['Float']['output']>;
  max_intensity?: Maybe<Scalars['Float']['output']>;
  min_intensity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Printweb_Spot_Color_Stddev_Samp_Fields = {
  __typename?: 'printweb_spot_color_stddev_samp_fields';
  line_width?: Maybe<Scalars['Float']['output']>;
  max_intensity?: Maybe<Scalars['Float']['output']>;
  min_intensity?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "printweb_spot_color" */
export type Printweb_Spot_Color_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Printweb_Spot_Color_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Printweb_Spot_Color_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  do_overprint?: InputMaybe<Scalars['Boolean']['input']>;
  fill_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Scalars['bytea']['input']>;
  internal_name?: InputMaybe<Scalars['String']['input']>;
  line_width?: InputMaybe<Scalars['numeric']['input']>;
  max_intensity?: InputMaybe<Scalars['numeric']['input']>;
  min_intensity?: InputMaybe<Scalars['numeric']['input']>;
  mixing_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  overprint_mode?: InputMaybe<Scalars['Boolean']['input']>;
  stroke_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  technical_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Printweb_Spot_Color_Sum_Fields = {
  __typename?: 'printweb_spot_color_sum_fields';
  line_width?: Maybe<Scalars['numeric']['output']>;
  max_intensity?: Maybe<Scalars['numeric']['output']>;
  min_intensity?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "printweb.spot_color" */
export enum Printweb_Spot_Color_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DoOverprint = 'do_overprint',
  /** column name */
  FillAllowed = 'fill_allowed',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  InternalName = 'internal_name',
  /** column name */
  LineWidth = 'line_width',
  /** column name */
  MaxIntensity = 'max_intensity',
  /** column name */
  MinIntensity = 'min_intensity',
  /** column name */
  MixingAllowed = 'mixing_allowed',
  /** column name */
  OverprintMode = 'overprint_mode',
  /** column name */
  StrokeAllowed = 'stroke_allowed',
  /** column name */
  TechnicalName = 'technical_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Printweb_Spot_Color_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Printweb_Spot_Color_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Printweb_Spot_Color_Set_Input>;
  /** filter the rows which have to be updated */
  where: Printweb_Spot_Color_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Printweb_Spot_Color_Var_Pop_Fields = {
  __typename?: 'printweb_spot_color_var_pop_fields';
  line_width?: Maybe<Scalars['Float']['output']>;
  max_intensity?: Maybe<Scalars['Float']['output']>;
  min_intensity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Printweb_Spot_Color_Var_Samp_Fields = {
  __typename?: 'printweb_spot_color_var_samp_fields';
  line_width?: Maybe<Scalars['Float']['output']>;
  max_intensity?: Maybe<Scalars['Float']['output']>;
  min_intensity?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Printweb_Spot_Color_Variance_Fields = {
  __typename?: 'printweb_spot_color_variance_fields';
  line_width?: Maybe<Scalars['Float']['output']>;
  max_intensity?: Maybe<Scalars['Float']['output']>;
  min_intensity?: Maybe<Scalars['Float']['output']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "printweb.background_material" */
  printweb_background_material: Array<Printweb_Background_Material>;
  /** fetch aggregated fields from the table: "printweb.background_material" */
  printweb_background_material_aggregate: Printweb_Background_Material_Aggregate;
  /** fetch data from the table: "printweb.background_material" using primary key columns */
  printweb_background_material_by_pk?: Maybe<Printweb_Background_Material>;
  /** fetch data from the table: "printweb.background_material_group" */
  printweb_background_material_group: Array<Printweb_Background_Material_Group>;
  /** fetch aggregated fields from the table: "printweb.background_material_group" */
  printweb_background_material_group_aggregate: Printweb_Background_Material_Group_Aggregate;
  /** fetch data from the table: "printweb.background_material_group" using primary key columns */
  printweb_background_material_group_by_pk?: Maybe<Printweb_Background_Material_Group>;
  /** fetch data from the table: "printweb.combinable_spot_colors" */
  printweb_combinable_spot_colors: Array<Printweb_Combinable_Spot_Colors>;
  /** fetch aggregated fields from the table: "printweb.combinable_spot_colors" */
  printweb_combinable_spot_colors_aggregate: Printweb_Combinable_Spot_Colors_Aggregate;
  /** fetch data from the table: "printweb.combinable_spot_colors" using primary key columns */
  printweb_combinable_spot_colors_by_pk?: Maybe<Printweb_Combinable_Spot_Colors>;
  /** fetch data from the table: "printweb.instance" */
  printweb_instance: Array<Printweb_Instance>;
  /** fetch aggregated fields from the table: "printweb.instance" */
  printweb_instance_aggregate: Printweb_Instance_Aggregate;
  /** fetch data from the table: "printweb.instance_background_material" */
  printweb_instance_background_material: Array<Printweb_Instance_Background_Material>;
  /** fetch aggregated fields from the table: "printweb.instance_background_material" */
  printweb_instance_background_material_aggregate: Printweb_Instance_Background_Material_Aggregate;
  /** fetch data from the table: "printweb.instance_background_material" using primary key columns */
  printweb_instance_background_material_by_pk?: Maybe<Printweb_Instance_Background_Material>;
  /** fetch data from the table: "printweb.instance" using primary key columns */
  printweb_instance_by_pk?: Maybe<Printweb_Instance>;
  /** fetch data from the table: "printweb.instance_spot_color" */
  printweb_instance_spot_color: Array<Printweb_Instance_Spot_Color>;
  /** fetch aggregated fields from the table: "printweb.instance_spot_color" */
  printweb_instance_spot_color_aggregate: Printweb_Instance_Spot_Color_Aggregate;
  /** fetch data from the table: "printweb.instance_spot_color" using primary key columns */
  printweb_instance_spot_color_by_pk?: Maybe<Printweb_Instance_Spot_Color>;
  /** fetch data from the table: "printweb.material_group" */
  printweb_material_group: Array<Printweb_Material_Group>;
  /** fetch aggregated fields from the table: "printweb.material_group" */
  printweb_material_group_aggregate: Printweb_Material_Group_Aggregate;
  /** fetch data from the table: "printweb.material_group" using primary key columns */
  printweb_material_group_by_pk?: Maybe<Printweb_Material_Group>;
  /** fetch data from the table: "printweb.material_label" */
  printweb_material_label: Array<Printweb_Material_Label>;
  /** fetch aggregated fields from the table: "printweb.material_label" */
  printweb_material_label_aggregate: Printweb_Material_Label_Aggregate;
  /** fetch data from the table: "printweb.material_label" using primary key columns */
  printweb_material_label_by_pk?: Maybe<Printweb_Material_Label>;
  /** fetch data from the table: "printweb.spot_color" */
  printweb_spot_color: Array<Printweb_Spot_Color>;
  /** fetch aggregated fields from the table: "printweb.spot_color" */
  printweb_spot_color_aggregate: Printweb_Spot_Color_Aggregate;
  /** fetch data from the table: "printweb.spot_color" using primary key columns */
  printweb_spot_color_by_pk?: Maybe<Printweb_Spot_Color>;
};


export type Query_RootPrintweb_Background_MaterialArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Background_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Background_Material_Order_By>>;
  where?: InputMaybe<Printweb_Background_Material_Bool_Exp>;
};


export type Query_RootPrintweb_Background_Material_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Background_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Background_Material_Order_By>>;
  where?: InputMaybe<Printweb_Background_Material_Bool_Exp>;
};


export type Query_RootPrintweb_Background_Material_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPrintweb_Background_Material_GroupArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Background_Material_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Background_Material_Group_Order_By>>;
  where?: InputMaybe<Printweb_Background_Material_Group_Bool_Exp>;
};


export type Query_RootPrintweb_Background_Material_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Background_Material_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Background_Material_Group_Order_By>>;
  where?: InputMaybe<Printweb_Background_Material_Group_Bool_Exp>;
};


export type Query_RootPrintweb_Background_Material_Group_By_PkArgs = {
  background_material_id: Scalars['uuid']['input'];
  material_group_id: Scalars['uuid']['input'];
};


export type Query_RootPrintweb_Combinable_Spot_ColorsArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Combinable_Spot_Colors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Combinable_Spot_Colors_Order_By>>;
  where?: InputMaybe<Printweb_Combinable_Spot_Colors_Bool_Exp>;
};


export type Query_RootPrintweb_Combinable_Spot_Colors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Combinable_Spot_Colors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Combinable_Spot_Colors_Order_By>>;
  where?: InputMaybe<Printweb_Combinable_Spot_Colors_Bool_Exp>;
};


export type Query_RootPrintweb_Combinable_Spot_Colors_By_PkArgs = {
  combinable_spot_color_id: Scalars['uuid']['input'];
  spot_color_id: Scalars['uuid']['input'];
};


export type Query_RootPrintweb_InstanceArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Instance_Order_By>>;
  where?: InputMaybe<Printweb_Instance_Bool_Exp>;
};


export type Query_RootPrintweb_Instance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Instance_Order_By>>;
  where?: InputMaybe<Printweb_Instance_Bool_Exp>;
};


export type Query_RootPrintweb_Instance_Background_MaterialArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Instance_Background_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Instance_Background_Material_Order_By>>;
  where?: InputMaybe<Printweb_Instance_Background_Material_Bool_Exp>;
};


export type Query_RootPrintweb_Instance_Background_Material_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Instance_Background_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Instance_Background_Material_Order_By>>;
  where?: InputMaybe<Printweb_Instance_Background_Material_Bool_Exp>;
};


export type Query_RootPrintweb_Instance_Background_Material_By_PkArgs = {
  background_material_id: Scalars['uuid']['input'];
  instance_id: Scalars['uuid']['input'];
};


export type Query_RootPrintweb_Instance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPrintweb_Instance_Spot_ColorArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Instance_Spot_Color_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Instance_Spot_Color_Order_By>>;
  where?: InputMaybe<Printweb_Instance_Spot_Color_Bool_Exp>;
};


export type Query_RootPrintweb_Instance_Spot_Color_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Instance_Spot_Color_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Instance_Spot_Color_Order_By>>;
  where?: InputMaybe<Printweb_Instance_Spot_Color_Bool_Exp>;
};


export type Query_RootPrintweb_Instance_Spot_Color_By_PkArgs = {
  instance_id: Scalars['uuid']['input'];
  spot_color_id: Scalars['uuid']['input'];
};


export type Query_RootPrintweb_Material_GroupArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Material_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Material_Group_Order_By>>;
  where?: InputMaybe<Printweb_Material_Group_Bool_Exp>;
};


export type Query_RootPrintweb_Material_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Material_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Material_Group_Order_By>>;
  where?: InputMaybe<Printweb_Material_Group_Bool_Exp>;
};


export type Query_RootPrintweb_Material_Group_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPrintweb_Material_LabelArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Material_Label_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Material_Label_Order_By>>;
  where?: InputMaybe<Printweb_Material_Label_Bool_Exp>;
};


export type Query_RootPrintweb_Material_Label_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Material_Label_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Material_Label_Order_By>>;
  where?: InputMaybe<Printweb_Material_Label_Bool_Exp>;
};


export type Query_RootPrintweb_Material_Label_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPrintweb_Spot_ColorArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Spot_Color_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Spot_Color_Order_By>>;
  where?: InputMaybe<Printweb_Spot_Color_Bool_Exp>;
};


export type Query_RootPrintweb_Spot_Color_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Spot_Color_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Spot_Color_Order_By>>;
  where?: InputMaybe<Printweb_Spot_Color_Bool_Exp>;
};


export type Query_RootPrintweb_Spot_Color_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "printweb.background_material" */
  printweb_background_material: Array<Printweb_Background_Material>;
  /** fetch aggregated fields from the table: "printweb.background_material" */
  printweb_background_material_aggregate: Printweb_Background_Material_Aggregate;
  /** fetch data from the table: "printweb.background_material" using primary key columns */
  printweb_background_material_by_pk?: Maybe<Printweb_Background_Material>;
  /** fetch data from the table: "printweb.background_material_group" */
  printweb_background_material_group: Array<Printweb_Background_Material_Group>;
  /** fetch aggregated fields from the table: "printweb.background_material_group" */
  printweb_background_material_group_aggregate: Printweb_Background_Material_Group_Aggregate;
  /** fetch data from the table: "printweb.background_material_group" using primary key columns */
  printweb_background_material_group_by_pk?: Maybe<Printweb_Background_Material_Group>;
  /** fetch data from the table in a streaming manner: "printweb.background_material_group" */
  printweb_background_material_group_stream: Array<Printweb_Background_Material_Group>;
  /** fetch data from the table in a streaming manner: "printweb.background_material" */
  printweb_background_material_stream: Array<Printweb_Background_Material>;
  /** fetch data from the table: "printweb.combinable_spot_colors" */
  printweb_combinable_spot_colors: Array<Printweb_Combinable_Spot_Colors>;
  /** fetch aggregated fields from the table: "printweb.combinable_spot_colors" */
  printweb_combinable_spot_colors_aggregate: Printweb_Combinable_Spot_Colors_Aggregate;
  /** fetch data from the table: "printweb.combinable_spot_colors" using primary key columns */
  printweb_combinable_spot_colors_by_pk?: Maybe<Printweb_Combinable_Spot_Colors>;
  /** fetch data from the table in a streaming manner: "printweb.combinable_spot_colors" */
  printweb_combinable_spot_colors_stream: Array<Printweb_Combinable_Spot_Colors>;
  /** fetch data from the table: "printweb.instance" */
  printweb_instance: Array<Printweb_Instance>;
  /** fetch aggregated fields from the table: "printweb.instance" */
  printweb_instance_aggregate: Printweb_Instance_Aggregate;
  /** fetch data from the table: "printweb.instance_background_material" */
  printweb_instance_background_material: Array<Printweb_Instance_Background_Material>;
  /** fetch aggregated fields from the table: "printweb.instance_background_material" */
  printweb_instance_background_material_aggregate: Printweb_Instance_Background_Material_Aggregate;
  /** fetch data from the table: "printweb.instance_background_material" using primary key columns */
  printweb_instance_background_material_by_pk?: Maybe<Printweb_Instance_Background_Material>;
  /** fetch data from the table in a streaming manner: "printweb.instance_background_material" */
  printweb_instance_background_material_stream: Array<Printweb_Instance_Background_Material>;
  /** fetch data from the table: "printweb.instance" using primary key columns */
  printweb_instance_by_pk?: Maybe<Printweb_Instance>;
  /** fetch data from the table: "printweb.instance_spot_color" */
  printweb_instance_spot_color: Array<Printweb_Instance_Spot_Color>;
  /** fetch aggregated fields from the table: "printweb.instance_spot_color" */
  printweb_instance_spot_color_aggregate: Printweb_Instance_Spot_Color_Aggregate;
  /** fetch data from the table: "printweb.instance_spot_color" using primary key columns */
  printweb_instance_spot_color_by_pk?: Maybe<Printweb_Instance_Spot_Color>;
  /** fetch data from the table in a streaming manner: "printweb.instance_spot_color" */
  printweb_instance_spot_color_stream: Array<Printweb_Instance_Spot_Color>;
  /** fetch data from the table in a streaming manner: "printweb.instance" */
  printweb_instance_stream: Array<Printweb_Instance>;
  /** fetch data from the table: "printweb.material_group" */
  printweb_material_group: Array<Printweb_Material_Group>;
  /** fetch aggregated fields from the table: "printweb.material_group" */
  printweb_material_group_aggregate: Printweb_Material_Group_Aggregate;
  /** fetch data from the table: "printweb.material_group" using primary key columns */
  printweb_material_group_by_pk?: Maybe<Printweb_Material_Group>;
  /** fetch data from the table in a streaming manner: "printweb.material_group" */
  printweb_material_group_stream: Array<Printweb_Material_Group>;
  /** fetch data from the table: "printweb.material_label" */
  printweb_material_label: Array<Printweb_Material_Label>;
  /** fetch aggregated fields from the table: "printweb.material_label" */
  printweb_material_label_aggregate: Printweb_Material_Label_Aggregate;
  /** fetch data from the table: "printweb.material_label" using primary key columns */
  printweb_material_label_by_pk?: Maybe<Printweb_Material_Label>;
  /** fetch data from the table in a streaming manner: "printweb.material_label" */
  printweb_material_label_stream: Array<Printweb_Material_Label>;
  /** fetch data from the table: "printweb.spot_color" */
  printweb_spot_color: Array<Printweb_Spot_Color>;
  /** fetch aggregated fields from the table: "printweb.spot_color" */
  printweb_spot_color_aggregate: Printweb_Spot_Color_Aggregate;
  /** fetch data from the table: "printweb.spot_color" using primary key columns */
  printweb_spot_color_by_pk?: Maybe<Printweb_Spot_Color>;
  /** fetch data from the table in a streaming manner: "printweb.spot_color" */
  printweb_spot_color_stream: Array<Printweb_Spot_Color>;
};


export type Subscription_RootPrintweb_Background_MaterialArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Background_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Background_Material_Order_By>>;
  where?: InputMaybe<Printweb_Background_Material_Bool_Exp>;
};


export type Subscription_RootPrintweb_Background_Material_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Background_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Background_Material_Order_By>>;
  where?: InputMaybe<Printweb_Background_Material_Bool_Exp>;
};


export type Subscription_RootPrintweb_Background_Material_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPrintweb_Background_Material_GroupArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Background_Material_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Background_Material_Group_Order_By>>;
  where?: InputMaybe<Printweb_Background_Material_Group_Bool_Exp>;
};


export type Subscription_RootPrintweb_Background_Material_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Background_Material_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Background_Material_Group_Order_By>>;
  where?: InputMaybe<Printweb_Background_Material_Group_Bool_Exp>;
};


export type Subscription_RootPrintweb_Background_Material_Group_By_PkArgs = {
  background_material_id: Scalars['uuid']['input'];
  material_group_id: Scalars['uuid']['input'];
};


export type Subscription_RootPrintweb_Background_Material_Group_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Printweb_Background_Material_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Printweb_Background_Material_Group_Bool_Exp>;
};


export type Subscription_RootPrintweb_Background_Material_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Printweb_Background_Material_Stream_Cursor_Input>>;
  where?: InputMaybe<Printweb_Background_Material_Bool_Exp>;
};


export type Subscription_RootPrintweb_Combinable_Spot_ColorsArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Combinable_Spot_Colors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Combinable_Spot_Colors_Order_By>>;
  where?: InputMaybe<Printweb_Combinable_Spot_Colors_Bool_Exp>;
};


export type Subscription_RootPrintweb_Combinable_Spot_Colors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Combinable_Spot_Colors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Combinable_Spot_Colors_Order_By>>;
  where?: InputMaybe<Printweb_Combinable_Spot_Colors_Bool_Exp>;
};


export type Subscription_RootPrintweb_Combinable_Spot_Colors_By_PkArgs = {
  combinable_spot_color_id: Scalars['uuid']['input'];
  spot_color_id: Scalars['uuid']['input'];
};


export type Subscription_RootPrintweb_Combinable_Spot_Colors_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Printweb_Combinable_Spot_Colors_Stream_Cursor_Input>>;
  where?: InputMaybe<Printweb_Combinable_Spot_Colors_Bool_Exp>;
};


export type Subscription_RootPrintweb_InstanceArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Instance_Order_By>>;
  where?: InputMaybe<Printweb_Instance_Bool_Exp>;
};


export type Subscription_RootPrintweb_Instance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Instance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Instance_Order_By>>;
  where?: InputMaybe<Printweb_Instance_Bool_Exp>;
};


export type Subscription_RootPrintweb_Instance_Background_MaterialArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Instance_Background_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Instance_Background_Material_Order_By>>;
  where?: InputMaybe<Printweb_Instance_Background_Material_Bool_Exp>;
};


export type Subscription_RootPrintweb_Instance_Background_Material_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Instance_Background_Material_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Instance_Background_Material_Order_By>>;
  where?: InputMaybe<Printweb_Instance_Background_Material_Bool_Exp>;
};


export type Subscription_RootPrintweb_Instance_Background_Material_By_PkArgs = {
  background_material_id: Scalars['uuid']['input'];
  instance_id: Scalars['uuid']['input'];
};


export type Subscription_RootPrintweb_Instance_Background_Material_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Printweb_Instance_Background_Material_Stream_Cursor_Input>>;
  where?: InputMaybe<Printweb_Instance_Background_Material_Bool_Exp>;
};


export type Subscription_RootPrintweb_Instance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPrintweb_Instance_Spot_ColorArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Instance_Spot_Color_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Instance_Spot_Color_Order_By>>;
  where?: InputMaybe<Printweb_Instance_Spot_Color_Bool_Exp>;
};


export type Subscription_RootPrintweb_Instance_Spot_Color_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Instance_Spot_Color_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Instance_Spot_Color_Order_By>>;
  where?: InputMaybe<Printweb_Instance_Spot_Color_Bool_Exp>;
};


export type Subscription_RootPrintweb_Instance_Spot_Color_By_PkArgs = {
  instance_id: Scalars['uuid']['input'];
  spot_color_id: Scalars['uuid']['input'];
};


export type Subscription_RootPrintweb_Instance_Spot_Color_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Printweb_Instance_Spot_Color_Stream_Cursor_Input>>;
  where?: InputMaybe<Printweb_Instance_Spot_Color_Bool_Exp>;
};


export type Subscription_RootPrintweb_Instance_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Printweb_Instance_Stream_Cursor_Input>>;
  where?: InputMaybe<Printweb_Instance_Bool_Exp>;
};


export type Subscription_RootPrintweb_Material_GroupArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Material_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Material_Group_Order_By>>;
  where?: InputMaybe<Printweb_Material_Group_Bool_Exp>;
};


export type Subscription_RootPrintweb_Material_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Material_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Material_Group_Order_By>>;
  where?: InputMaybe<Printweb_Material_Group_Bool_Exp>;
};


export type Subscription_RootPrintweb_Material_Group_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPrintweb_Material_Group_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Printweb_Material_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Printweb_Material_Group_Bool_Exp>;
};


export type Subscription_RootPrintweb_Material_LabelArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Material_Label_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Material_Label_Order_By>>;
  where?: InputMaybe<Printweb_Material_Label_Bool_Exp>;
};


export type Subscription_RootPrintweb_Material_Label_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Material_Label_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Material_Label_Order_By>>;
  where?: InputMaybe<Printweb_Material_Label_Bool_Exp>;
};


export type Subscription_RootPrintweb_Material_Label_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPrintweb_Material_Label_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Printweb_Material_Label_Stream_Cursor_Input>>;
  where?: InputMaybe<Printweb_Material_Label_Bool_Exp>;
};


export type Subscription_RootPrintweb_Spot_ColorArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Spot_Color_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Spot_Color_Order_By>>;
  where?: InputMaybe<Printweb_Spot_Color_Bool_Exp>;
};


export type Subscription_RootPrintweb_Spot_Color_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Printweb_Spot_Color_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Printweb_Spot_Color_Order_By>>;
  where?: InputMaybe<Printweb_Spot_Color_Bool_Exp>;
};


export type Subscription_RootPrintweb_Spot_Color_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPrintweb_Spot_Color_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Printweb_Spot_Color_Stream_Cursor_Input>>;
  where?: InputMaybe<Printweb_Spot_Color_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type InstanceFragment = { __typename?: 'printweb_instance', allowed_url?: string | null, created_at: string, updated_at: string, id: string, name: string };

export type SpotColorFragment = { __typename?: 'printweb_spot_color', id: string, display_name: string, technical_name: string, internal_name: string, fill_allowed: boolean, do_overprint: boolean, min_intensity: number, max_intensity: number, stroke_allowed: boolean, mixing_allowed?: boolean | null, line_width?: number | null, created_at: string, updated_at: string, overprint_mode: boolean };

export type BackgroundMaterialFragment = { __typename?: 'printweb_background_material', id: string, display_name: string, internal_name: string, label_id?: string | null, created_at: string, updated_at: string, background_material_groups: Array<{ __typename?: 'printweb_background_material_group', material_group: { __typename?: 'printweb_material_group', id: string, name: string } }> };

export type MaterialLabelFragment = { __typename?: 'printweb_material_label', id: string, name: string, created_at: string, updated_at: string };

export type MaterialGroupFragment = { __typename?: 'printweb_material_group', id: string, name: string, created_at: string, updated_at: string };

export type DeleteInstanceMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteInstanceMutation = { __typename?: 'mutation_root', delete_printweb_instance_by_pk?: { __typename?: 'printweb_instance', id: string } | null };

export type InsertInstanceMutationVariables = Exact<{
  objects?: InputMaybe<Array<Printweb_Instance_Insert_Input> | Printweb_Instance_Insert_Input>;
}>;


export type InsertInstanceMutation = { __typename?: 'mutation_root', insert_printweb_instance?: { __typename?: 'printweb_instance_mutation_response', returning: Array<{ __typename?: 'printweb_instance', id: string }> } | null };

export type UpdateInstanceMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  header_logo?: InputMaybe<Scalars['bytea']['input']>;
  allowed_url?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateInstanceMutation = { __typename?: 'mutation_root', update_printweb_instance?: { __typename?: 'printweb_instance_mutation_response', returning: Array<{ __typename?: 'printweb_instance', id: string }> } | null };

export type DeleteInstanceMaterialsMutationVariables = Exact<{
  instance_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteInstanceMaterialsMutation = { __typename?: 'mutation_root', delete_printweb_instance_background_material?: { __typename?: 'printweb_instance_background_material_mutation_response', returning: Array<{ __typename?: 'printweb_instance_background_material', instance_id: string, background_material_id: string }> } | null };

export type DeleteInstanceColorsMutationVariables = Exact<{
  instance_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteInstanceColorsMutation = { __typename?: 'mutation_root', delete_printweb_instance_spot_color?: { __typename?: 'printweb_instance_spot_color_mutation_response', returning: Array<{ __typename?: 'printweb_instance_spot_color', instance_id: string, spot_color_id: string }> } | null };

export type DeleteSpotColorMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteSpotColorMutation = { __typename?: 'mutation_root', delete_printweb_spot_color_by_pk?: { __typename?: 'printweb_spot_color', id: string } | null };

export type InsertSpotColorMutationVariables = Exact<{
  updateFields: Printweb_Spot_Color_Insert_Input;
}>;


export type InsertSpotColorMutation = { __typename?: 'mutation_root', insert_printweb_spot_color_one?: { __typename?: 'printweb_spot_color', id: string } | null };

export type UpdateSpotColorMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  _set?: InputMaybe<Printweb_Spot_Color_Set_Input>;
}>;


export type UpdateSpotColorMutation = { __typename?: 'mutation_root', update_printweb_spot_color_by_pk?: { __typename?: 'printweb_spot_color', id: string } | null };

export type DeleteBackgroundMaterialMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteBackgroundMaterialMutation = { __typename?: 'mutation_root', delete_printweb_background_material_by_pk?: { __typename?: 'printweb_background_material', id: string } | null };

export type InsertBackground_MaterialMutationVariables = Exact<{
  updateFields: Printweb_Background_Material_Insert_Input;
}>;


export type InsertBackground_MaterialMutation = { __typename?: 'mutation_root', insert_printweb_background_material_one?: { __typename?: 'printweb_background_material', id: string } | null };

export type UpdateMaterialBackgroundMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  _set?: InputMaybe<Printweb_Background_Material_Set_Input>;
}>;


export type UpdateMaterialBackgroundMutation = { __typename?: 'mutation_root', update_printweb_background_material_by_pk?: { __typename?: 'printweb_background_material', id: string } | null };

export type InsertInstanceMaterialBackgroundMutationVariables = Exact<{
  objects?: InputMaybe<Array<Printweb_Instance_Background_Material_Insert_Input> | Printweb_Instance_Background_Material_Insert_Input>;
}>;


export type InsertInstanceMaterialBackgroundMutation = { __typename?: 'mutation_root', insert_printweb_instance_background_material?: { __typename?: 'printweb_instance_background_material_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'printweb_instance_background_material', background_material_id: string, instance_id: string }> } | null };

export type InsertInstanceSpotColorMutationVariables = Exact<{
  objects?: InputMaybe<Array<Printweb_Instance_Spot_Color_Insert_Input> | Printweb_Instance_Spot_Color_Insert_Input>;
}>;


export type InsertInstanceSpotColorMutation = { __typename?: 'mutation_root', insert_printweb_instance_spot_color?: { __typename?: 'printweb_instance_spot_color_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'printweb_instance_spot_color', instance_id: string, spot_color_id: string }> } | null };

export type InsertMaterialLabelMutationVariables = Exact<{
  updateFields: Printweb_Material_Label_Insert_Input;
}>;


export type InsertMaterialLabelMutation = { __typename?: 'mutation_root', insert_printweb_material_label_one?: { __typename?: 'printweb_material_label', id: string } | null };

export type UpdateMaterialLabelMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  _set?: InputMaybe<Printweb_Material_Label_Set_Input>;
}>;


export type UpdateMaterialLabelMutation = { __typename?: 'mutation_root', update_printweb_material_label_by_pk?: { __typename?: 'printweb_material_label', id: string } | null };

export type DeleteMaterialLabelMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteMaterialLabelMutation = { __typename?: 'mutation_root', delete_printweb_material_label_by_pk?: { __typename?: 'printweb_material_label', id: string } | null };

export type InsertMaterialGroupMutationVariables = Exact<{
  updateFields: Printweb_Material_Group_Insert_Input;
}>;


export type InsertMaterialGroupMutation = { __typename?: 'mutation_root', insert_printweb_material_group_one?: { __typename?: 'printweb_material_group', id: string } | null };

export type UpdateMaterialGroupMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  _set?: InputMaybe<Printweb_Material_Group_Set_Input>;
}>;


export type UpdateMaterialGroupMutation = { __typename?: 'mutation_root', update_printweb_material_group_by_pk?: { __typename?: 'printweb_material_group', id: string } | null };

export type DeleteMaterialGroupMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteMaterialGroupMutation = { __typename?: 'mutation_root', delete_printweb_material_group_by_pk?: { __typename?: 'printweb_material_group', id: string } | null };

export type DeleteBackgroundMaterialGroupsMutationVariables = Exact<{
  materialId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteBackgroundMaterialGroupsMutation = { __typename?: 'mutation_root', delete_printweb_background_material_group?: { __typename?: 'printweb_background_material_group_mutation_response', returning: Array<{ __typename?: 'printweb_background_material_group', background_material_id: string, material_group_id: string }> } | null };

export type InsertBackgroundMaterialGroupsMutationVariables = Exact<{
  objects?: InputMaybe<Array<Printweb_Background_Material_Group_Insert_Input> | Printweb_Background_Material_Group_Insert_Input>;
}>;


export type InsertBackgroundMaterialGroupsMutation = { __typename?: 'mutation_root', insert_printweb_background_material_group?: { __typename?: 'printweb_background_material_group_mutation_response', returning: Array<{ __typename?: 'printweb_background_material_group', background_material_id: string, material_group_id: string }> } | null };

export type DeleteCombinableColorsMutationVariables = Exact<{
  spotColorId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteCombinableColorsMutation = { __typename?: 'mutation_root', delete_printweb_combinable_spot_colors?: { __typename?: 'printweb_combinable_spot_colors_mutation_response', returning: Array<{ __typename?: 'printweb_combinable_spot_colors', combinable_spot_color_id: string, spot_color_id: string }> } | null };

export type InsertCombinableColorsMutationVariables = Exact<{
  objects?: InputMaybe<Array<Printweb_Combinable_Spot_Colors_Insert_Input> | Printweb_Combinable_Spot_Colors_Insert_Input>;
}>;


export type InsertCombinableColorsMutation = { __typename?: 'mutation_root', insert_printweb_combinable_spot_colors?: { __typename?: 'printweb_combinable_spot_colors_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'printweb_combinable_spot_colors', combinable_spot_color_id: string, spot_color_id: string }> } | null };

export type InstanceByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type InstanceByIdQuery = { __typename?: 'query_root', printweb_instance: Array<{ __typename?: 'printweb_instance', allowed_url?: string | null, created_at: string, updated_at: string, id: string, name: string, background_materials: Array<{ __typename?: 'printweb_instance_background_material', background_material: { __typename?: 'printweb_background_material', id: string, display_name: string, internal_name: string, label_id?: string | null, created_at: string, updated_at: string, background_material_groups: Array<{ __typename?: 'printweb_background_material_group', material_group: { __typename?: 'printweb_material_group', id: string, name: string } }> } }>, spot_colors: Array<{ __typename?: 'printweb_instance_spot_color', spot_color: { __typename?: 'printweb_spot_color', id: string, display_name: string, technical_name: string, internal_name: string, fill_allowed: boolean, do_overprint: boolean, min_intensity: number, max_intensity: number, stroke_allowed: boolean, mixing_allowed?: boolean | null, line_width?: number | null, created_at: string, updated_at: string, overprint_mode: boolean, combinable_colors: Array<{ __typename?: 'printweb_combinable_spot_colors', spot_color: { __typename?: 'printweb_spot_color', id: string, display_name: string, technical_name: string, internal_name: string, fill_allowed: boolean, do_overprint: boolean, min_intensity: number, max_intensity: number, stroke_allowed: boolean, mixing_allowed?: boolean | null, line_width?: number | null, created_at: string, updated_at: string, overprint_mode: boolean } }> } }> }> };

export type InstanceImageByIdQueryVariables = Exact<{
  instanceIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type InstanceImageByIdQuery = { __typename?: 'query_root', printweb_instance: Array<{ __typename?: 'printweb_instance', id: string, header_logo: any }> };

export type ColorImageByIdQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type ColorImageByIdQuery = { __typename?: 'query_root', printweb_spot_color: Array<{ __typename?: 'printweb_spot_color', id: string, image: any }> };

export type MaterialImageByIdQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type MaterialImageByIdQuery = { __typename?: 'query_root', printweb_background_material: Array<{ __typename?: 'printweb_background_material', id: string, image: any }> };

export type FetchInstancesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type FetchInstancesSubscription = { __typename?: 'subscription_root', printweb_instance: Array<{ __typename?: 'printweb_instance', allowed_url?: string | null, created_at: string, updated_at: string, id: string, name: string, background_materials: Array<{ __typename?: 'printweb_instance_background_material', background_material: { __typename?: 'printweb_background_material', id: string, display_name: string, internal_name: string, label_id?: string | null, created_at: string, updated_at: string, background_material_groups: Array<{ __typename?: 'printweb_background_material_group', material_group: { __typename?: 'printweb_material_group', id: string, name: string } }> } }>, spot_colors: Array<{ __typename?: 'printweb_instance_spot_color', spot_color: { __typename?: 'printweb_spot_color', id: string, display_name: string, technical_name: string, internal_name: string, fill_allowed: boolean, do_overprint: boolean, min_intensity: number, max_intensity: number, stroke_allowed: boolean, mixing_allowed?: boolean | null, line_width?: number | null, created_at: string, updated_at: string, overprint_mode: boolean } }> }> };

export type FetchSpotColorsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type FetchSpotColorsSubscription = { __typename?: 'subscription_root', printweb_spot_color: Array<{ __typename?: 'printweb_spot_color', id: string, display_name: string, technical_name: string, internal_name: string, fill_allowed: boolean, do_overprint: boolean, min_intensity: number, max_intensity: number, stroke_allowed: boolean, mixing_allowed?: boolean | null, line_width?: number | null, created_at: string, updated_at: string, overprint_mode: boolean, combinable_colors: Array<{ __typename?: 'printweb_combinable_spot_colors', spot_color: { __typename?: 'printweb_spot_color', id: string, display_name: string, technical_name: string, internal_name: string, fill_allowed: boolean, do_overprint: boolean, min_intensity: number, max_intensity: number, stroke_allowed: boolean, mixing_allowed?: boolean | null, line_width?: number | null, created_at: string, updated_at: string, overprint_mode: boolean } }> }> };

export type FetchBackgroundMaterialsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type FetchBackgroundMaterialsSubscription = { __typename?: 'subscription_root', printweb_background_material: Array<{ __typename?: 'printweb_background_material', id: string, display_name: string, internal_name: string, label_id?: string | null, created_at: string, updated_at: string, material_label?: { __typename?: 'printweb_material_label', id: string, name: string } | null, background_material_groups: Array<{ __typename?: 'printweb_background_material_group', material_group: { __typename?: 'printweb_material_group', id: string, name: string } }> }> };

export type SubscribeMaterialLabelsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeMaterialLabelsSubscription = { __typename?: 'subscription_root', printweb_material_label: Array<{ __typename?: 'printweb_material_label', id: string, name: string, created_at: string, updated_at: string, background_materials: Array<{ __typename?: 'printweb_background_material', id: string, display_name: string, internal_name: string, label_id?: string | null, created_at: string, updated_at: string, background_material_groups: Array<{ __typename?: 'printweb_background_material_group', material_group: { __typename?: 'printweb_material_group', id: string, name: string } }> }> }> };

export type SubscribeMaterialGroupsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeMaterialGroupsSubscription = { __typename?: 'subscription_root', printweb_material_group: Array<{ __typename?: 'printweb_material_group', id: string, name: string, created_at: string, updated_at: string }> };

export type SubscribeMaterialGroupsAndMaterialsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeMaterialGroupsAndMaterialsSubscription = { __typename?: 'subscription_root', printweb_material_group: Array<{ __typename?: 'printweb_material_group', id: string, name: string, created_at: string, updated_at: string, material_group_background_materials: Array<{ __typename?: 'printweb_background_material_group', background_material: { __typename?: 'printweb_background_material', id: string, display_name: string, internal_name: string, label_id?: string | null, created_at: string, updated_at: string, background_material_groups: Array<{ __typename?: 'printweb_background_material_group', material_group: { __typename?: 'printweb_material_group', id: string, name: string } }> } }> }> };

export const InstanceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Instance"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_instance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed_url"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<InstanceFragment, unknown>;
export const SpotColorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotColor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_spot_color"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"technical_name"}},{"kind":"Field","name":{"kind":"Name","value":"internal_name"}},{"kind":"Field","name":{"kind":"Name","value":"fill_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"do_overprint"}},{"kind":"Field","name":{"kind":"Name","value":"min_intensity"}},{"kind":"Field","name":{"kind":"Name","value":"max_intensity"}},{"kind":"Field","name":{"kind":"Name","value":"stroke_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"mixing_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"line_width"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"overprint_mode"}}]}}]} as unknown as DocumentNode<SpotColorFragment, unknown>;
export const BackgroundMaterialFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BackgroundMaterial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_background_material"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"internal_name"}},{"kind":"Field","name":{"kind":"Name","value":"label_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"background_material_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"material_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<BackgroundMaterialFragment, unknown>;
export const MaterialLabelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaterialLabel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_material_label"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<MaterialLabelFragment, unknown>;
export const MaterialGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaterialGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_material_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<MaterialGroupFragment, unknown>;
export const DeleteInstanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteInstance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_printweb_instance_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteInstanceMutation, DeleteInstanceMutationVariables>;
export const InsertInstanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertInstance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_instance_insert_input"}}}},"defaultValue":{"kind":"ListValue","values":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_printweb_instance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<InsertInstanceMutation, InsertInstanceMutationVariables>;
export const UpdateInstanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInstance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"header_logo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"bytea"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allowed_url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_printweb_instance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowed_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allowed_url"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"header_logo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"header_logo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateInstanceMutation, UpdateInstanceMutationVariables>;
export const DeleteInstanceMaterialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteInstanceMaterials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instance_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_printweb_instance_background_material"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"instance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instance_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instance_id"}},{"kind":"Field","name":{"kind":"Name","value":"background_material_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteInstanceMaterialsMutation, DeleteInstanceMaterialsMutationVariables>;
export const DeleteInstanceColorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteInstanceColors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instance_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_printweb_instance_spot_color"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"instance_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instance_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instance_id"}},{"kind":"Field","name":{"kind":"Name","value":"spot_color_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteInstanceColorsMutation, DeleteInstanceColorsMutationVariables>;
export const DeleteSpotColorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSpotColor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_printweb_spot_color_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteSpotColorMutation, DeleteSpotColorMutationVariables>;
export const InsertSpotColorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertSpotColor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateFields"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_spot_color_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_printweb_spot_color_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateFields"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertSpotColorMutation, InsertSpotColorMutationVariables>;
export const UpdateSpotColorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSpotColor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_set"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_spot_color_set_input"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_printweb_spot_color_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateSpotColorMutation, UpdateSpotColorMutationVariables>;
export const DeleteBackgroundMaterialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteBackgroundMaterial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_printweb_background_material_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteBackgroundMaterialMutation, DeleteBackgroundMaterialMutationVariables>;
export const InsertBackground_MaterialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertBACKGROUND_MATERIAL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateFields"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_background_material_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_printweb_background_material_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateFields"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertBackground_MaterialMutation, InsertBackground_MaterialMutationVariables>;
export const UpdateMaterialBackgroundDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMaterialBackground"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_set"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_background_material_set_input"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_printweb_background_material_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMaterialBackgroundMutation, UpdateMaterialBackgroundMutationVariables>;
export const InsertInstanceMaterialBackgroundDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertInstanceMaterialBackground"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_instance_background_material_insert_input"}}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_printweb_instance_background_material"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background_material_id"}},{"kind":"Field","name":{"kind":"Name","value":"instance_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertInstanceMaterialBackgroundMutation, InsertInstanceMaterialBackgroundMutationVariables>;
export const InsertInstanceSpotColorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertInstanceSpotColor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_instance_spot_color_insert_input"}}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_printweb_instance_spot_color"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instance_id"}},{"kind":"Field","name":{"kind":"Name","value":"spot_color_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertInstanceSpotColorMutation, InsertInstanceSpotColorMutationVariables>;
export const InsertMaterialLabelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertMaterialLabel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateFields"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_material_label_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_printweb_material_label_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateFields"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertMaterialLabelMutation, InsertMaterialLabelMutationVariables>;
export const UpdateMaterialLabelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMaterialLabel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_set"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_material_label_set_input"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_printweb_material_label_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMaterialLabelMutation, UpdateMaterialLabelMutationVariables>;
export const DeleteMaterialLabelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMaterialLabel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_printweb_material_label_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteMaterialLabelMutation, DeleteMaterialLabelMutationVariables>;
export const InsertMaterialGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertMaterialGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateFields"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_material_group_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_printweb_material_group_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateFields"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertMaterialGroupMutation, InsertMaterialGroupMutationVariables>;
export const UpdateMaterialGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMaterialGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_set"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_material_group_set_input"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_printweb_material_group_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMaterialGroupMutation, UpdateMaterialGroupMutationVariables>;
export const DeleteMaterialGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMaterialGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_printweb_material_group_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteMaterialGroupMutation, DeleteMaterialGroupMutationVariables>;
export const DeleteBackgroundMaterialGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteBackgroundMaterialGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"materialId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_printweb_background_material_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"background_material_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"materialId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background_material_id"}},{"kind":"Field","name":{"kind":"Name","value":"material_group_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteBackgroundMaterialGroupsMutation, DeleteBackgroundMaterialGroupsMutationVariables>;
export const InsertBackgroundMaterialGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertBackgroundMaterialGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_background_material_group_insert_input"}}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_printweb_background_material_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background_material_id"}},{"kind":"Field","name":{"kind":"Name","value":"material_group_id"}}]}}]}}]}}]} as unknown as DocumentNode<InsertBackgroundMaterialGroupsMutation, InsertBackgroundMaterialGroupsMutationVariables>;
export const DeleteCombinableColorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCombinableColors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spotColorId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_printweb_combinable_spot_colors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"spot_color_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spotColorId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"combinable_spot_color_id"}},{"kind":"Field","name":{"kind":"Name","value":"spot_color_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteCombinableColorsMutation, DeleteCombinableColorsMutationVariables>;
export const InsertCombinableColorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertCombinableColors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_combinable_spot_colors_insert_input"}}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_printweb_combinable_spot_colors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"combinable_spot_color_id"}},{"kind":"Field","name":{"kind":"Name","value":"spot_color_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertCombinableColorsMutation, InsertCombinableColorsMutationVariables>;
export const InstanceByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InstanceById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"printweb_instance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Instance"}},{"kind":"Field","name":{"kind":"Name","value":"background_materials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background_material"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BackgroundMaterial"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"spot_colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spot_color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotColor"}},{"kind":"Field","name":{"kind":"Name","value":"combinable_colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spot_color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotColor"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Instance"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_instance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed_url"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BackgroundMaterial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_background_material"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"internal_name"}},{"kind":"Field","name":{"kind":"Name","value":"label_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"background_material_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"material_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotColor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_spot_color"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"technical_name"}},{"kind":"Field","name":{"kind":"Name","value":"internal_name"}},{"kind":"Field","name":{"kind":"Name","value":"fill_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"do_overprint"}},{"kind":"Field","name":{"kind":"Name","value":"min_intensity"}},{"kind":"Field","name":{"kind":"Name","value":"max_intensity"}},{"kind":"Field","name":{"kind":"Name","value":"stroke_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"mixing_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"line_width"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"overprint_mode"}}]}}]} as unknown as DocumentNode<InstanceByIdQuery, InstanceByIdQueryVariables>;
export const InstanceImageByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InstanceImageById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instanceIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"printweb_instance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instanceIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"header_logo"}}]}}]}}]} as unknown as DocumentNode<InstanceImageByIdQuery, InstanceImageByIdQueryVariables>;
export const ColorImageByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ColorImageById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"printweb_spot_color"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]} as unknown as DocumentNode<ColorImageByIdQuery, ColorImageByIdQueryVariables>;
export const MaterialImageByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MaterialImageById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"printweb_background_material"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]} as unknown as DocumentNode<MaterialImageByIdQuery, MaterialImageByIdQueryVariables>;
export const FetchInstancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"fetchInstances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"printweb_instance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Instance"}},{"kind":"Field","name":{"kind":"Name","value":"background_materials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background_material"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BackgroundMaterial"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"spot_colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spot_color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotColor"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Instance"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_instance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed_url"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BackgroundMaterial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_background_material"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"internal_name"}},{"kind":"Field","name":{"kind":"Name","value":"label_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"background_material_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"material_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotColor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_spot_color"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"technical_name"}},{"kind":"Field","name":{"kind":"Name","value":"internal_name"}},{"kind":"Field","name":{"kind":"Name","value":"fill_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"do_overprint"}},{"kind":"Field","name":{"kind":"Name","value":"min_intensity"}},{"kind":"Field","name":{"kind":"Name","value":"max_intensity"}},{"kind":"Field","name":{"kind":"Name","value":"stroke_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"mixing_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"line_width"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"overprint_mode"}}]}}]} as unknown as DocumentNode<FetchInstancesSubscription, FetchInstancesSubscriptionVariables>;
export const FetchSpotColorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"fetchSpotColors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"printweb_spot_color"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotColor"}},{"kind":"Field","name":{"kind":"Name","value":"combinable_colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spot_color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpotColor"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpotColor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_spot_color"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"technical_name"}},{"kind":"Field","name":{"kind":"Name","value":"internal_name"}},{"kind":"Field","name":{"kind":"Name","value":"fill_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"do_overprint"}},{"kind":"Field","name":{"kind":"Name","value":"min_intensity"}},{"kind":"Field","name":{"kind":"Name","value":"max_intensity"}},{"kind":"Field","name":{"kind":"Name","value":"stroke_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"mixing_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"line_width"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"overprint_mode"}}]}}]} as unknown as DocumentNode<FetchSpotColorsSubscription, FetchSpotColorsSubscriptionVariables>;
export const FetchBackgroundMaterialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"fetchBackgroundMaterials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"printweb_background_material"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"material_label"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BackgroundMaterial"}},{"kind":"Field","name":{"kind":"Name","value":"material_label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"background_material_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"material_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BackgroundMaterial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_background_material"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"internal_name"}},{"kind":"Field","name":{"kind":"Name","value":"label_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"background_material_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"material_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<FetchBackgroundMaterialsSubscription, FetchBackgroundMaterialsSubscriptionVariables>;
export const SubscribeMaterialLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"subscribeMaterialLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"printweb_material_label"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaterialLabel"}},{"kind":"Field","name":{"kind":"Name","value":"background_materials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BackgroundMaterial"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaterialLabel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_material_label"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BackgroundMaterial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_background_material"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"internal_name"}},{"kind":"Field","name":{"kind":"Name","value":"label_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"background_material_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"material_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<SubscribeMaterialLabelsSubscription, SubscribeMaterialLabelsSubscriptionVariables>;
export const SubscribeMaterialGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"subscribeMaterialGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"printweb_material_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaterialGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaterialGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_material_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<SubscribeMaterialGroupsSubscription, SubscribeMaterialGroupsSubscriptionVariables>;
export const SubscribeMaterialGroupsAndMaterialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"subscribeMaterialGroupsAndMaterials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"printweb_material_group"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MaterialGroup"}},{"kind":"Field","name":{"kind":"Name","value":"material_group_background_materials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background_material"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BackgroundMaterial"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MaterialGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_material_group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BackgroundMaterial"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"printweb_background_material"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"internal_name"}},{"kind":"Field","name":{"kind":"Name","value":"label_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"background_material_groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"material_group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<SubscribeMaterialGroupsAndMaterialsSubscription, SubscribeMaterialGroupsAndMaterialsSubscriptionVariables>;